import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import { useReactToPrint } from "react-to-print";
import { inboxActions } from "../../_store";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import EmojiPicker from "../../components/common/EmojiPicker";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import writeMessageSchema from "../../validation/writeMessageSchema";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import InboxPopup from "../../components/common/UI/Inputs/NotificationModal/InboxPopup.jsx";
import useDraft from "../../components/common/autoSaveDraftMsg/useDraft";
import {
  writeMessageActions,
  purchaseCreditsActions,
  sendPhotosActions,
  myContactsActions,
  archivedActions,
} from "../../_store";
import { ReactNotifications } from "react-notifications-component";
import doubleTick from "../../../src/assets/images/double-tick-indicator.png";
import tick from "../../../src/assets/images/tick.png";
import {
  restrictCharacters,
  getGraphemes,
  isEmoji,
} from "../../utils/keywordBlocker.js";
import translations from "../../config/TranslateFile.jsx";
import { CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog.jsx";
// import { removeUnallowedEmojis } from "../../utils/keywordBlocker.js";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import GraphemeSplitter from 'grapheme-splitter';
import useCheckQuarantineWords from "../../hooks/useCheckQuarantineWords.jsx";
import { object } from "joi";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import { checkEmojiRegex, commonemojiRegex, getDifference } from "../../components/common/emoji-whitelist.js";

function Messenger() {
  const userID = getStoredValue("userID");
  const navigate = useNavigate();
  const location = useLocation();
  const componentRef = useRef();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { handleDraftChange, setIsDraftModified, clearDraft } = useDraft();
  // const photo = useSelector(
  //   (state) => state.sendPhotos.LoadPhotosDetailsResponse
  // );
  const photo = useSelector(
    (state) => state.sendPhotos.LoadPhotosDetailsResponse
  );
  const currentLang = translations();
  const PublicInboxMessageSubjectList1 = useSelector(
    (state) => state.inbox.PublicInboxMessageSubjectList
  );
  const [IsHasMsgEmojiPermission, setIsHasMsgEmojiPermission] = useState(false);
  const [codMessageID, setCODMessageID] = useState(0);
  const MsgPhotoStatusResponse = useSelector(
    (state) => state.sendPhotos.CheckingMsgPhotoStatusResponse
  );
  const CheckInmateConnectionStatus = useSelector(
    (state) => state.sendPhotos.CheckInmateConnectionStatus
  );
  const [isPrintData, setisPrintData] = useState(false);
  const [isPrintTable, setisPrintTable] = useState(false);
  const [ColumnOrderdata, setColumnOrderData] = useState(Date);
  const [emojiEnabled, setIsEmojiEnable] = useState(true);
  const [deleteMesssagePopup, setDeleteMessagePopup] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [messageDisabled, setMessageDisabled] = useState("");
  const [isMessageDisabled, setIsMessageDisabled] = useState(false);
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState({});
  const [multiCODCost, setMultiCODCost] = useState(0);
  const [multiCODPopupReject, setMultiCODPopupReject] = useState(false);
  const [multiCODPopup, setMultiCODPopup] = useState(false);
  const [multiDeleteConfirmation, setMultiDeleteConfirmation] = useState(false);
  const [filterStatusResponse, setFilterStatusResponse] = useState(false);
  const isInsertingFromPicker = useRef(false);
  const prevValueRef = useRef("");
  const lastKeyRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const publicUserId = getStoredValue("userID");
  // State for Select All checkbox (Multi Delete)
  const [selectAllMultiDeleteChecked, setSelectAllMultiDeleteChecked] =
    useState(false);
  const LoadQuarantineWords = useCheckQuarantineWords();
  const currentMenuName = useSelector((x) => x.master.currentMenuName);
  const [keywordPopup, setKeywordPopup] = useState(false);
  const [foundKeyword, setFoundKeyword] = useState("");
  const isAnyCheckboxChecked = Object.values(isCheckboxChecked).some(
    (value) => value
  );

  const previousPath = location.state?.from;
  const draftFromValue = previousPath === "/public/Archived" ? 2 : 1;

  const defaultParams = {
    userID: userID,
    inmateID: 0,
    subject: "",
    fromDate: "",
    toDate: "",
    messageStatus: 0,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  };

  // Initial state for send message
  const initialMessage = {
    userID: userID,
    inmatesId: 0,
    facilityID: 0,
    sender: "PublicUser",
    receiver: "Inmate",
    subject: "",
    messageBody: "",
    messageCost: 0,
    isReplyMsg: 1,
    replyMessageID: 0,
    isSALoginAsPU: 0,
    creditAccountType: 0,
    taskGUID: "",
    taskNo: 0,
    draftID: 0,
    isEmojiUsed: false,
    messageEmojiCost: 0,
    MessageID: 0,
  };

  // Inital state for save as draft
  const initialDraft = {
    draftID: 0,
    publicUserId: userID,
    inmateID: 0,
    subject: "",
    messageBody: "",
    draftFromValue: draftFromValue,
    messageID: 0,
    isSALoginAsPU: 0,
    action: 0,
  };

  const [disabledItems, setDisabledItems] = useState({
    newMessage: false,
    messageHistory: false,
    purchaseCredits: false,
    filterCODMessage: false,
    cancelConnection: false,
    printMessage: false,
    deleteConversation: false,
    IsQuarantine: false
  });

  const [deleteConversation, setDeleteConversation] = useState(false);
  // Draft Message Emoji Used but emoji permission canceled in inbox
  const [emonjiStatusPopup, setemonjiStatusPopup] = useState(false);

  const [message, setMessage] = useState(initialMessage);
  const [newMessage, setNewMessage] = useState(false);
  const [inboxHistoryPopup, setInboxHistoryPopup] = useState(false);
  const [purchaseCreditPopup, setPurchaseCreditPopup] = useState(false);
  const [cancelConnectionPopup, setCancelConnectionPopup] = useState(false);

  const [isCreditamountModal, setisCreditamountModal] = useState(false);
  const [msgCreditamount, setMsgCreditamount] = useState("");

  const [connectionStatusID, setConnectionStatusID] = useState("");
  const [deleteMessageID, setDeleteMessageID] = useState(null);

  const [draft, setDraft] = useState(initialDraft);
  const [isDescIconPickerOpen, setIsDescIconPickerOpen] = useState(false);
  const [errors, setErrors] = useState();
  const descInputRef = useRef(null);
  const [SendMessageConfirmation, setSendMessageConfirmation] = useState(false);
  const [shouldDisplayHTMLMessage, setShouldDisplayHTMLMessage] =
    useState(false);

  const [codInfoPopup, setCODInfoPopup] = useState(false);
  const hasShownPopup = useRef(false); // Tracks if the popup has been shown
  const { isSignalRData, connectionData } = useSelector((state) => state.auth);
  const [cODApproveRejectMessage, setCODApproveRejectMessage] = useState(false);
  const dispatch = useDispatch();
  const [pageNo, setPageNo] = useState(1);
  const [selectedChatId, setSelectedChatId] = useState(null);
  const chatContainerRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchHistoryList, setSearchHistoryList] = useState("");
  const [textMessageContent, setTextMessageContent] = useState("");
  const [showSearchFields, setShowSearchFields] = useState(false);
  const [messageDetails, setMessageDetails] = useState(null);
  const [PUIConnectionID, setPUIConnectionID] = useState(null);
  const { inboxMessagesList, loading, error } = useSelector(
    (state) => state.inbox || {}
  );
  const [PublicInboxMessageSubjectList, setPublicInboxMessageSubjectList] =
    useState([]);
  const [currentPage, setCurrentPage] = useState(defaultParams.pageNo);
  const [publicInboxMessageHistoryList, setPublicInboxMessageHistoryList] =
    useState([]);
  const filteredMessages = inboxMessagesList.filter(
    (message) =>
      message.MessageFrom?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      message.MessageSubjectText?.toLowerCase().includes(
        searchQuery.toLowerCase()
      )
  );

  const toggleSelection = (id) => {
    setSelectedMessages((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((msgId) => msgId !== id)
        : [...prevSelected, id]
    );
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Replace <br/> with a newline (\n) or space (In side COD Reject Method)
  //  const formattedMessage = message.replace(/<br\/>/g, '\n'); // Or replace with ' ' for space

  // Function for Draft emoji used but emoji permission cancelled
  const handleEmonjiStatusPopupConfirm = () => {
    setMessage((prevState) => ({
      ...prevState,
      messageBody: "", // Clear the message body
    }));
    setemonjiStatusPopup(false); // Close the popup
  };

  const handleEmonjiStatusPopupClose = () => {
    // This should close the popup when clicking "No"
    setemonjiStatusPopup(false);
  };

  // Status for Cancel Connection
  const UpdateInmateConnectionResponse = useSelector(
    (state) => state.sendPhotos.UpdateInmateConnection
  );

  // State for COD Message Handling
  const [isCODFilterActive, setCODFilterActive] = useState(false);
  const [multiDeleteMenuActive, setMultiDeleteMenuActive] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);

  // Delete Message State
  const [selectedDeleteMessages, setSelectedDeleteMessages] = useState([]);

  // Load Subject - Handle chat item click
  const handleChatItemClick = useCallback(
    (MessageID, PublicUserID, CODMessageCount, messagesDetails) => {
      if (CODMessageCount > 0) {
        setSelectedMessage({ MessageID, PublicUserID });
        setCodAlertMessage(true);
      }

      // Reset some states
      //setPublicInboxMessageHistoryList([]);
      setPageNo(1);
      setSelectedChatId({ MessageID, PublicUserID });
      setMessage((prevState) => ({
        ...prevState,
        MessageID: MessageID,
      }));

      setPublicInboxMessageSubjectList([]);
      // Only dispatch if necessary (e.g., no existing data or if the data changed)
      dispatch(
        inboxActions.LoadPublicInboxMessageSubject({ MessageID, PublicUserID })
      ).then((response) => {
        if (response.payload && response.payload.length > 0) {
          const data = response.payload[0];
          setPublicInboxMessageSubjectList(data); // Assuming one subject is returned
          handleDraftChange("subject", data?.MessageSubjectText);
          handleDraftChange("inmateID", data?.InmateID);
          handleDraftChange("messageID", message?.MessageID);
          handleDraftChange("draftID", draft?.draftID);
          handleDraftChange("action", 0);
          // handleDraftChange("draftFromValue", draftFromValue);
          setIsDraftModified(true);
          // Update message state if necessary
          setMessage((prevState) => ({
            ...prevState,
            inmatesId: data?.InmateID,
            subject: data?.MessageSubjectText,
            messageCost: data?.FacilityMessageCost,
            replyMessageID: data?.SourceReplyMessageID,
            facilityID: data?.FacilityID,
          }));
          setPUIConnectionID(data?.PUIConnectionID);
          setIsEmojiEnable(data?.IsEmojiEnabled);
          setConnectionStatusID(data?.ConnectionStatusID);
          // if (data?.ConnectionStatusID === 3 || data?.ConnectionStatusID === 4 || data?.ConnectionStatusID === 5 ) {
          //   setDisabledItems({
          //     newMessage: true,
          //     messageHistory: false,
          //     purchaseCredits: true,
          //     cancelConnection: true,
          //     printMessage: false,
          //   });
          // }
          OnloadDisableFields(data);

          setDraft((prevState) => ({
            ...prevState,
            inmateID: data?.InmateID,
            subject: data?.MessageSubjectText,
            messageID: data?.MessageID,
          }));
          if (messagesDetails?.MessageStatus !== "Read") {
            const publicUserId = getStoredValue("userID");
            if (publicUserId) {
              dispatch(
                archivedActions.PULoginUnreadNotificationCount({ publicUserId })
              );
            }
          }
        }
        //
        CreateEventLogTextFileForInbox(
          dispatch,
          `${currentMenuName} - Load Chat Header ( Message ID - ${location?.state?.MessageID} )`,
          "---",
          JSON?.stringify(response.payload),
          "---"
        );
      });

      // Clear unnecessary states only if needed
      setTextMessageContent("");
      setIsDraftEdited(false);
    },
    [dispatch]
  );

  // On load Disabled function
  const OnloadDisableFields = (messages) => {
    if (messages?.IsAllowSendReply !== 1) {
      setIsMessageDisabled(true);
      setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
      setDisabledItems((prevState) => ({
        ...prevState, // Preserve previous state
        newMessage: true,
        purchaseCredits: true,
        cancelConnection: true,
      }));
      if (messages?.ActiveStatus !== 1) {
        setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
        setDisabledItems((prevState) => ({
          ...prevState, // Preserve previous state
          newMessage: true,
          purchaseCredits: true,
          cancelConnection: true,
          filterCODMessage: true,
          deleteConversation: true,
        }));
        setDeleteConversation(true);
      } else if (messages?.InmateStatus === 0) {
        setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
        let IsCancelConnection = true;
        if (messages?.ConnectionStatusID === 2) {
          IsCancelConnection = false;
        } else {
          IsCancelConnection = true;
        }
        setDisabledItems((prevState) => ({
          ...prevState, // Preserve previous state
          newMessage: true,
          purchaseCredits: true,
          cancelConnection: IsCancelConnection,
          filterCODMessage: true,
          deleteConversation: true,
        }));
        setDeleteConversation(true);
      } else if (
        messages?.IsAllowSendReply != 1 &&
        messages?.ConnectionStatusID == 2
      ) {
        setMessageDisabled(
          "The Permission to send Message to this contact has been restricted. ."
        );
        setDisabledItems((prevState) => ({
          ...prevState, // Preserve previous state
          purchaseCredits: false,
          cancelConnection: false,
        }));
      }
    } else {
      setDisabledItems((prevState) => ({
        ...prevState, // Preserve previous state
        newMessage: false,
        purchaseCredits: false,
        cancelConnection: false,
      }));
      setIsMessageDisabled(false);
    }

    if (messages?.Blocked === 1) {
      setDisabledItems((prevState) => ({
        ...prevState, // Preserve previous state
        newMessage: true,
        purchaseCredits: true,
      }));
    } else if (
      messages?.MessageLockdown === 1 ||
      messages?.MessagePODAccess === 0
    ) {
      setDisabledItems((prevState) => ({
        ...prevState, // Preserve previous state
        newMessage: true,
      }));
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
      month: 'short',    // Jul
      day: 'numeric',    // 24
      year: 'numeric',   // 2025
      hour: 'numeric',   // 4
      minute: '2-digit', // 58
      hour12: true       // AM/PM
    };
    let formatted = new Intl.DateTimeFormat('en-US', options).format(date);
    formatted = formatted.replace(',', '').replace(' ', '').replace(/(\d)(AM|PM)/, '$1 $2');
    return formatted;
  };

  const handleSubject = () => {
    const MessageID = isSignalRData?.message?.MessageID;
    const PublicUserID = publicUserId;
    dispatch(inboxActions.LoadPublicInboxMessageSubject({ MessageID, PublicUserID })).then((x => {
      if (publicUserId) {
        dispatch(archivedActions.PULoginUnreadNotificationCount({ publicUserId }));
      }
    }))
  }

  useEffect(() => {
    const replyMessageId = publicInboxMessageHistoryList?.length > 0 ? publicInboxMessageHistoryList[0]?.ReplyMessageID || publicInboxMessageHistoryList[0]?.SourceReplyMessageID : 0
    const isSignalRreplyMessageId = isSignalRData?.message?.ReplyMessageID || isSignalRData?.message?.SourceReplyMessageID;
    switch (isSignalRData?.type) {
      case 'Send_Msg':
        if (publicInboxMessageHistoryList?.length > 0 && isSignalRreplyMessageId == replyMessageId) {
          setPublicInboxMessageHistoryList(prevMessages => [
            { ...isSignalRData?.message, MessageBodyText: isSignalRData?.message?.MessageBody, }
            , ...prevMessages
          ]);
          handleSubject();
        }

        // below code is temperorily Add reason inmate and public user same time message COD message added so replace Add below code
        // const updatedmsg = publicInboxMessageHistoryList?.map(card => {
        //   if (card?.MessageID == isSignalRData?.message?.MessageID) {
        //     const msgtext = card?.Sender == "PublicUser" ?
        //       card?.MessageBody : isSignalRData?.message?.MessageBody
        //     return {
        //       ...card, MessageBody: msgtext,
        //       MessageBodyText: msgtext, MessageStatus: "Read",
        //     };
        //   }
        //   return card;
        // });
        // setPublicInboxMessageHistoryList(updatedmsg);
        break;
      case "Rejected_Msg":
        const updatedchat = publicInboxMessageHistoryList?.map(card => {
          if (card?.MessageID == isSignalRData?.message?.MessageID) {
            const msgtext = card?.Sender == "PublicUser" ?
              card?.MessageBody + " <br/><br/><br/>" + "(Inmate canceled this message on - " + formatDate(isSignalRData?.message?.MessageSentDate) + " )"
              : "(Inmate canceled this message on - " + formatDate(isSignalRData?.message?.MessageSentDate) + " )"
            return {
              ...card, MessageBody: msgtext, IsSenderMsgDelete: true,
              MessageBodyText: msgtext, MessageStatus: "C.O.D Pending"
            };
          }
          return card;
        });
        setPublicInboxMessageHistoryList(updatedchat);
        handleSubject();
        break;
      case "Approved_Msg":
        const updatedchatlist = publicInboxMessageHistoryList?.map(card => {
          if (card?.MessageID == isSignalRData?.message?.MessageID) {
            const msgtext = card?.Sender == "PublicUser" ?
              card?.MessageBody : isSignalRData?.message?.MessageBody

            if (connectionData?._connectionState == "Connected" && isSignalRData?.message?.Sender == "Inmate") {
              let MessageID = card?.MessageID; let PublicUserID = publicUserId
              dispatch(inboxActions.LoadPublicInboxMessageSubject({ MessageID, PublicUserID }));
              connectionData.invoke("SendSignalRMessagetoInmate", { ...PublicInboxMessageSubjectList, Messagetxt: msgtext, MessageID: parseInt(isSignalRData?.message?.MessageID) })
            }
            else if (connectionData?._connectionState == "Connected") {
              connectionData.invoke("SendSignalRMessagetoPU", { ...PublicInboxMessageSubjectList, Messagetxt: msgtext, MessageID: parseInt(isSignalRData?.message?.MessageID) })
            }

            return {
              ...card, MessageBody: msgtext,
              MessageBodyText: msgtext, MessageStatus: "Read",
            };
          }
          return card;
        });
        setPublicInboxMessageHistoryList(updatedchatlist);
        break;
      case "Read_Msg":
        if (isSignalRreplyMessageId == replyMessageId) {
          const updatedchatlists = publicInboxMessageHistoryList?.map(card => {
            if (card?.MessageStatus == "Unread") {
              return {
                ...card, MessageStatus: "Read",
              };
            }
            return card;
          });
          setPublicInboxMessageHistoryList(updatedchatlists);
        }
        break;
      case "COD_Read_Msg":
        if (isSignalRreplyMessageId == replyMessageId) {
          const updatedchatlists = publicInboxMessageHistoryList?.map(card => {
            if (card?.MessageID == isSignalRData?.message?.MessageID) {
              return {
                ...card, MessageStatus: "Read", MessageBody: isSignalRData?.message?.Messagetxt,
                MessageBodyText: isSignalRData?.message?.Messagetxt,
              };
            }
            return card;
          });
          setTimeout(() => {
            setPublicInboxMessageHistoryList(updatedchatlists);
          }, 1000);
        }
        break;
    }

  }, [isSignalRData]);

  // Load Message Conversation History List
  const loadMoreMessages = async (MessageID, PublicUserID, page, from) => {
    const isHoldCOD = 0;
    const rowCountPerPage = 20;
    // if (from === "save") {
    //   setPublicInboxMessageHistoryList([]);
    // }

    await dispatch(
      inboxActions.LoadPublicInboxMessageHistory({
        MessageID,
        isHoldCOD,
        pageNo: page,
        rowCountPerPage,
      })
    ).then((historyResponse) => {
      //
      CreateEventLogTextFileForInbox(
        dispatch,
        isHoldCOD === 1
          ? currentMenuName +
          " Menu - Load Chat History - Filtered COD Messages -  ( Message ID - " +
          MessageID +
          " ) "
          : currentMenuName +
          " Menu - Load Chat History ( Message ID - " +
          MessageID +
          " )",
        "---",
        JSON?.stringify(historyResponse.payload),
        "---"
      );
      //  setPublicInboxMessageHistoryList([]);
      if (historyResponse.payload && historyResponse.payload.length > 0) {
        // setPublicInboxMessageHistoryList(historyResponse.payload);
        if (from === "save") {
          setPublicInboxMessageHistoryList(historyResponse.payload);
        }
        else {
          setPublicInboxMessageHistoryList((prevState) => [
            ...prevState,
            ...historyResponse.payload,
          ]);
        }
        const sourceList =
          filteredMessageHistoryList && filteredMessageHistoryList.length > 0
            ? filteredMessageHistoryList
            : historyResponse.payload;
        const filteredMessages = sourceList.filter(
          (message) =>
            message?.MessageStatus === "C.O.D Pending" &&
            !message?.IsSenderMsgDelete

        );

        if (filteredMessages?.length === 0) {
          setShowCheckbox(false); // If no COD Message means hide MultiCOD - SelectAll Check Box
        } else if (filteredMessages?.length > 0 && isCODFilterActive) {
          setShowCheckbox(true); // If no COD Message means hide MultiCOD - SelectAll Check Box
        }

        // Multi Delete Menu Hide or show logic handled below
        const messagesExceptLast = sourceList.slice(0, sourceList.length - 1);

        // Check if any of these messages is from "Inmate"
        const isInmateInPreviousMessages = messagesExceptLast.some(
          (message) => message.Sender === "Inmate"
        );
        // If at least one previous message is from "Inmate", set the conversation state to true for deletion
        if (isInmateInPreviousMessages && !isCODFilterActive) {
          setDisabledItems((prevState) => ({
            ...prevState, // spread the previous state
            deleteConversation: false, // set deleteConversation to true
          }));
        } else {
          setDisabledItems((prevState) => ({
            ...prevState, // spread the previous state
            deleteConversation: true, // set deleteConversation to true
          }));
        }
      }
    });
  };

  const EmptyMessageState = () => {
    prevValueRef.current = ""
    setMessage((prevState) => ({
      ...prevState,
      messageBody: "",
    }));
    setDraft((prevState) => ({
      ...prevState,
      messageBody: "",
      draftID: 0,
    }));
    setMessageDetails((prevstate) => ({
      ...prevstate,
      messageBody: "",
      MessageBodyText: "",
      DraftID: 0,
    }));
  };

  useEffect(() => {
    if (location.state) {
      setMessageDetails(location.state);
    } else {
      const defaultState = getStoredValue("messageDetails");
      if (defaultState) {
        setMessageDetails(JSON.parse(defaultState));
      }
    }
  }, [location]);

  useEffect(() => {
    if (messageDetails) {
      setStoredValue("messageDetails", messageDetails);
    }
  }, [messageDetails]);

  // result for Message status
  useEffect(() => {
    if (CheckInmateConnectionStatus != null) {
      const InmateDetails = CheckInmateConnectionStatus;
      if (InmateDetails.length > 0) {
        setNewMessage(false);
        if (
          InmateDetails[0].ConnectionStatusID == 3 ||
          InmateDetails[0].ConnectionStatusID == 4 ||
          InmateDetails[0].ConnectionStatusID == 5
        ) {
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setIsMessageDisabled(true);
          setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
          }));
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        } else if (
          InmateDetails[0].IsMessageAcess == 0 ||
          InmateDetails[0].MessageAccess == 0
        ) {
          setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
          setIsPaymentMsg(true);
          setIsMessageDisabled(true);
          setMessageDisabled(currentLang?.InboxPopContent?.No_Permission);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
          }));
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        } else if (InmateDetails[0].ActiveStatus == 0) {
          setPaymentMsg(currentLang?.InboxPopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          setIsMessageDisabled(true);
          setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
            filterCODMessage: true,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        } else if (InmateDetails[0].Blocked === 1) {
          setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
            filterCODMessage: true,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        } else if (
          InmateDetails[0].MessageLockdown === 1 ||
          InmateDetails[0].MessagePODAccess === 0
        ) {
          setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            cancelConnection: true,
            filterCODMessage: true,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        } else {
          navigate("/public/WriteMessage", {
            state: { newMessageID: message?.inmatesId },
          });
          storeCurrentRoute("/public/WriteMessage");
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
      }
    }
  }, [CheckInmateConnectionStatus, dispatch]);

  // Purchase History Response
  useEffect(() => {
    if (
      MsgPhotoStatusResponse !== null &&
      MsgPhotoStatusResponse !== undefined
    ) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      EmptyMessageState();
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
          }));

          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
            filterCODMessage: true,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            purchaseCredits: true,
            cancelConnection: true,
            filterCODMessage: true,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          // setPaymentMsg("The Permission to send Message to this contact has been restricted. .");
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: true,
            messageHistory: false,
            purchaseCredits: false,
            cancelConnection: true,
            filterCODMessage: true,
            printMessage: false,
            deleteConversation: true,
          }));
          setDeleteConversation(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          setDisabledItems((prevstate) => ({
            ...prevstate,
            newMessage: false,
            messageHistory: false,
            purchaseCredits: true,
            cancelConnection: false,
            filterCODMessage: false,
            printMessage: false,
            deleteConversation: false,
          }));
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            // If success response (result = 0), redirect
            setStoredValue("InmateID", parseInt(message?.inmatesId));
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          }
          break;
      }
      setPurchaseCreditPopup(false);
    }
  }, [MsgPhotoStatusResponse]);

  useEffect(() => {
    if (UpdateInmateConnectionResponse === 1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Request_Cancelled_Success,
        type: "success",
      });
      setDisabledItems((prevstate) => ({
        ...prevstate,
        newMessage: true,
        messageHistory: false,
        purchaseCredits: true,
        cancelConnection: true,
        filterCODMessage: false,
        printMessage: false,
      }));
      setIsMessageDisabled(true);
      setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
    } else if (UpdateInmateConnectionResponse === -1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Operation_Failed,
        type: "error",
      });
    } else if (UpdateInmateConnectionResponse === -2) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByInmate,
        type: "warning",
      });
    } else if (UpdateInmateConnectionResponse === -3) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByInmate,
        type: "warning",
      });
    } else if (UpdateInmateConnectionResponse === -4) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByPU,
        type: "warning",
      });
      setDisabledItems((prevstate) => ({
        ...prevstate,
        newMessage: true,
        messageHistory: false,
        purchaseCredits: true,
        cancelConnection: true,
        filterCODMessage: false,
        printMessage: false,
      }));
      setIsMessageDisabled(true);
      setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
    } else if (UpdateInmateConnectionResponse === -5) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByPU,
        type: "warning",
      });
      setDisabledItems((prevstate) => ({
        ...prevstate,
        newMessage: true,
        messageHistory: false,
        purchaseCredits: true,
        cancelConnection: true,
        filterCODMessage: false,
        printMessage: false,
      }));
      setIsMessageDisabled(true);
      setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
    } else if (UpdateInmateConnectionResponse === -6) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Inmate_Limit_Exceeded,
        type: "warning",
      });
    }
  }, [UpdateInmateConnectionResponse]);

  // UseEffect to load more messages when selectedChatId changes
  useEffect(() => {
    if (selectedChatId && selectedChatId.MessageID) {
      loadMoreMessages(
        selectedChatId.MessageID,
        selectedChatId.PublicUserID,
        1,
        "save"
      );
    }
  }, [selectedChatId]);

  // Handle message details from location state
  useEffect(() => {
    if (location.state) {
      setMessageDetails(location.state);
    }
  }, [location]);

  // Trigger chat item click when message details are set
  useEffect(() => {
    if (messageDetails) {
      handleChatItemClick(
        messageDetails?.MessageID,
        messageDetails?.PublicUserID,
        messageDetails?.CODMessageCount,
        messageDetails?.messages
      );
      setTextMessageContent(messageDetails.MessageBody || "");
    }
  }, [messageDetails, handleChatItemClick]);



  const [sendemonjiRectPopup, setsendemonjiRectPopup] = useState(false);
  const emojiPickerRef = useRef(null);
  const [isMessageFocused, setIsMessageFocused] = useState(false);

  const handleMessageFocus = () => {
    setIsMessageFocused(true);
  };

  const handleMessageBlur = (e) => {
    if (
      emojiPickerRef.current &&
      emojiPickerRef.current.contains(e.relatedTarget)
    ) {
      return; // Don't close the emoji picker if the click is inside it
    }
    setIsMessageFocused(false);
    // setIsDescIconPickerOpen(false);
  };

  const handlesendemonjiRectPopupClose = () => {
    setsendemonjiRectPopup(false);
  };

  useEffect(() => {
    if (messageDetails?.DraftID !== 0 && messageDetails?.DraftID) {
      dispatch(
        writeMessageActions.GetDraftMessageDetails({
          DraftID: messageDetails?.DraftID,
        })
      ).then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          hideLoader();
          let status = response.payload;

          if (status.length > 0) {
            const messageBody = status[0].MessageBody;

            // Emoji check: if emojis are present and IsEmojiEnabled is false, show the popup
            var emojiRegex =
              /[\uD800-\uDBFF][\uDC00-\uDFFF]|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
            if (
              emojiRegex.test(messageBody) &&
              status[0].IsEmojiEnabled === false
            ) {
              setemonjiStatusPopup(true);
            } else {
              setemonjiStatusPopup(false);
            }

            setIsDraftEdited(true);
          }
        } else {
          setIsDraftEdited(false);
        }
      });
    }

    if (messageDetails?.DraftID !== 0 && messageDetails) {

      // multiple time Api call so temperarily commented
      // Handle chat item click logic for messageDetails
      // handleChatItemClick(
      //   messageDetails?.MessageID,
      //   messageDetails?.PublicUserID,
      //   messageDetails?.CODMessageCount,
      //   messageDetails?.DraftID
      // );

      // Update draft state based on messageDetails
      if (messageDetails?.DraftID !== undefined) {
        setDraft((prevState) => ({
          ...prevState,
          draftID: messageDetails?.DraftID,
        }));
      }
      prevValueRef.current = messageDetails.MessageBody || "";
      setDraft((prevState) => ({
        ...prevState,
        messageBody: messageDetails.MessageBody,
      }));
      setTextMessageContent(messageDetails.MessageBody || ""); // Set the message content
      setMessage((prevMessage) => ({
        ...prevMessage,
        messageBody: messageDetails.MessageBody,
      }));
      setMessage((prevState) => ({
        ...prevState,
        draftID: 0, // Clear the message body
      }));
    }
  }, [messageDetails, handleChatItemClick]);

  // const handleScroll = () => {
  //   const chatContainer = chatContainerRef.current;
  //   if (
  //     chatContainer.scrollHeight - chatContainer.scrollTop ===
  //     chatContainer.clientHeight
  //   ) {
  //      setTimeout(() => {
  //     setPageNo((prevPageNo) => {
  //       const newPage = prevPageNo + 1;
  //       loadMoreMessages(
  //         selectedChatId.MessageID,
  //         selectedChatId.PublicUserID,
  //         newPage
  //       );
  //       return newPage;
  //     });
  //      }, 100);
  //   }
  // };

  // Write Message - Section
  // Toggles the visibility of the emoji picker for either the subject or message body fields, ensuring only one picker is open at a time and setting focus to the relevant input.

  const handleScroll = () => {
    const chatContainer = chatContainerRef.current;
    if (!chatContainer) return;

    const isScrolledToBottom =
      chatContainer.scrollHeight - chatContainer.scrollTop <=
      chatContainer.clientHeight + 1;

    if (isScrolledToBottom) {
      // setTimeout(() => {
      setPageNo((prevPageNo) => {
        const newPage = prevPageNo + 1;
        loadMoreMessages(
          selectedChatId.MessageID,
          selectedChatId.PublicUserID,
          newPage
        );
        return newPage;
      });
      // }, 100);
    }
  };

  const handleIconClick = (field) => {
    // setIsDescIconPickerOpen(false);
    setIsDescIconPickerOpen((prevState) => !prevState);
    descInputRef.current.focus();
  };

  const toggleSearchFields = () => {
    setShowSearchFields(!showSearchFields);
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };

  // Filter the messages based on the search query
  const filteredMessageHistoryList =
    publicInboxMessageHistoryList?.filter((message) =>
      message?.MessageBodyText.toLowerCase().includes(
        searchHistoryList.toLowerCase()
      )
    ) || [];


  // C.O.D - Filter Logic Hanlding
  const codMessages = filteredMessageHistoryList.filter(
    (message) => message?.MessageStatus === "C.O.D Pending"
  );

  const messagesToShow = isCODFilterActive
    ? codMessages
    : filteredMessageHistoryList;

  const handleFilterCODMessages = () => {
    // Show the popup
    // setCODFilterActive(!isCODFilterActive);
    setCODFilterActive(!isCODFilterActive);

    setMultiDeleteMenuActive(false);
    setSelectedDeleteMessages([]);
    setIsSelectAllChecked(false);
    setSelectedMessages([]); // Reset selected messages when toggling
    const filteredMessages = filteredMessageHistoryList.filter(
      (message) =>
        message?.MessageStatus === "C.O.D Pending" &&
        !message?.IsSenderMsgDelete
    );
    if (filteredMessages.length !== 0) {
      setShowCheckbox(!showCheckbox);
      setCODInfoPopup(true);
    } else {
      setShowCheckbox(false);
    }
    setIsCheckboxChecked(!isAnyCheckboxChecked);

    let CODActive = !isCODFilterActive;
    if (!isCODFilterActive) {
      // When COD filter is active, enable deleteConversation
      setDisabledItems((prevstate) => ({
        ...prevstate,
        deleteConversation: !false,
      }));
    } else {
      // When COD filter is not active, filter out certain messages
      const filteredMessages = filteredMessageHistoryList.filter(
        (message, index) => {
          // Exclude the last index value
          if (index === filteredMessageHistoryList.length - 1) {
            return false;
          }

          // Apply the condition for other messages
          return (
            message.Sender === "Inmate" && message.IsSenderMsgDelete === false
          );
        }
      );

      if (filteredMessages.length > 0) {
        // If there are valid messages, disable deleteConversation
        setDisabledItems((prevstate) => ({
          ...prevstate,
          deleteConversation: !true,
        }));
      } else {
        // If no valid messages exist, enable deleteConversation
        setDisabledItems((prevstate) => ({
          ...prevstate,
          deleteConversation: !false,
        }));
      }
    }

    if (!showCheckbox) {
      //irukku
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Filter COD Message Filter in Chat History (Message ID - ${location?.state?.MessageID} `,
        "---",
        "---",
        "Show Filtered COD Messages"
      );
    } else {
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Undo COD Message in Chat History (Message ID - ${location?.state?.MessageID} `,
        "---",
        "---",
        "undo COD Filtered Messages"
      );
    }
  };

  // filter Status Response
  useEffect(() => {
    if (filterStatusResponse && filteredMessageHistoryList.length > 0) {
      handleMultiCancelMessages();
    }
    if (filteredMessageHistoryList.length > 0 && isCODFilterActive) {
      const filteredMessages = filteredMessageHistoryList.filter(
        (message) =>
          message.MessageStatus === "C.O.D Pending" &&
          !message?.IsSenderMsgDelete
      );
      const result = Object.entries(isCheckboxChecked)
        .filter(([key, value]) => value.checked) // Filter only checked items
        .map(([key, value]) => {
          return key;
        });
      if (
        filteredMessages.length > 0 &&
        filteredMessages.length !== result.length
      ) {
        setIsSelectAllChecked(false);
      }
    }
  }, [filterStatusResponse, filteredMessageHistoryList]);

  // Update the character count display
  const maxDescriptionLength = 2000;

  const [codAlertMessage, setCodAlertMessage] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const codUpdate = (message) => {
    setMessage((prevState) => {
      const facilityMessageCost = message?.FacilityMessageCost ?? 0;
      const facilityEmojiCost = message?.FacilityEmojiCost ?? 0;
      const debitCostOfFacility = message?.DebitCostOfFacility ?? 0; // Default to 0 if null/undefined

      const messageEmojiCostFormatted =
        facilityEmojiCost !== 0
          ? (debitCostOfFacility - facilityMessageCost).toFixed(2)
          : "0.00";

      return {
        ...prevState,
        messageCost: debitCostOfFacility.toFixed(2),
        messageEmojiCost: messageEmojiCostFormatted,
      };
    });

    setCODMessageID(message?.MessageID);
    setCODApproveRejectMessage(true);
    // setShowCheckbox(!showCheckbox);

    //Event log for popup
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup`,
      "---",
      "What would you like to do?",
      "Shows Approve or Reject Confirmation popup"
    );
  };

  const MulitCodUpdate = () => {
    let totalCost = 0;
    let emojiCostTotal = 0;
    let messageCost = 0;

    // Iterate through isCheckboxChecked state
    Object.entries(isCheckboxChecked).forEach(([messageId, value]) => {
      if (value.checked) {
        // Get the costs for this message subject
        //let { totalCost: calcTotalCost, emojiCostTotal: calcEmojiCost, messageCost: calcMessageCost } = multiCalCulateMessageCost(value.subject);
        const CodFiltered = value.message;
        const facilityMessageCost = CodFiltered?.FacilityMessageCost ?? 0;
        const facilityEmojiCost = CodFiltered?.FacilityEmojiCost ?? 0;
        const debitCostOfFacility = CodFiltered?.DebitCostOfFacility ?? 0;
        const messageEmojiCostFormatted =
          facilityEmojiCost !== 0
            ? (debitCostOfFacility - facilityMessageCost).toFixed(2)
            : 0;

        // Accumulate costs
        totalCost += parseFloat(debitCostOfFacility);
        emojiCostTotal +=
          messageEmojiCostFormatted !== "0.00"
            ? parseFloat(messageEmojiCostFormatted)
            : 0;
        messageCost += facilityMessageCost;
      }
    });
    setMessage((prevState) => {
      return {
        ...prevState,
        messageCost: totalCost?.toFixed(2),
        messageEmojiCost:
          emojiCostTotal !== 0 && emojiCostTotal !== null
            ? emojiCostTotal?.toFixed(2)
            : 0,
      };
    });
    setMultiCODCost(messageCost);

    setCODMessageID(message?.MessageID);
    setMultiCODPopup(true);
    // setShowCheckbox(!showCheckbox);
  };

  // Draft message data will be displayed in inbox.

  //display the update draft button

  const [isDraftEdited, setIsDraftEdited] = useState(false);

  // Handles saving the message as a draft by validating the message body, updating the draft state, and dispatching the draft action, with appropriate notifications based on the response status.
  const handleSaveasDraft = (e) => {
    e?.preventDefault();
    // setDraftActive(true);
    // Update the draft state and run validation/dispatch after the state is set
    setDraft((prevState) => {
      const updatedDraft = {
        ...prevState,
        subject: message.subject,
        messageBody: message.messageBody,
      };
      setDraft((prevState) => ({
        ...prevState,
        draftID: prevState.draftID || -1, // Temporary ID to indicate a draft is being created
      }));

      setErrors({});
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));

      // Validate only the messageBody field in updatedDraft
      const { error } = writeMessageSchema({
        messageBody: updatedDraft.messageBody,
      });

      // Filter and handle only messageBody errors
      const messageBodyError = error?.details?.find(
        (e) => e.path[0] === "messageBody"
      );
      if (messageBodyError) {
        setErrors({ messageBody: messageBodyError.message });
        document
          .querySelector("textarea[name='messageBody']")
          ?.classList.add("border-danger");
        return updatedDraft;
      }

      // Proceed if there are no validation errors
      showLoader();
      // Dispatch draft message action with updated draft
      dispatch(writeMessageActions.DraftMessageCUD(updatedDraft)).then(
        (response) => {
          hideLoader();
          if (response?.meta?.requestStatus === "fulfilled") {
            const status = response?.payload[0]?.ReturnStatus;
            /* Event Log */
            CreateEventLogTextFileForInbox(
              dispatch,
              `${currentMenuName} - Save Message as Draft ${updatedDraft?.messageBody}`,
              "---",
              "---",
              `${status !== null
                ? `Message saved as draft Successfully. Return Value - ${status?.toString()}`
                : `${status}`
              } `
            );

            let draftno = response?.payload[0]?.ReturnDraft;
            setDraft((prevState) => ({
              ...prevState,
              draftID: draftno,
            }));
            setMessage((prevState) => ({
              ...prevState,
              draftID: draftno,
            }));
            handleDraftChange("draftID", draftno);
            handleDraftChange("messageBody", message?.messageBody);
            handleDraftChange("subject", message?.subject);
            handleDraftChange("inmateID", message?.inmatesId);
            handleDraftChange("messageID", message?.MessageID);
            handleDraftChange("draftFromValue", draftFromValue);
            handleDraftChange("action", 0);
            setIsDraftModified(true);
            switch (status) {
              case 1:
                //  handleDraftChange("draftID", draftno);

                NotificationService({
                  title: currentLang?.Success,
                  message: currentLang?.DraftPopContent?.Draft_Saved_Success,
                  type: "success",
                });
                const publicUserId = getStoredValue("userID");
                dispatch(
                  archivedActions.PULoginUnreadNotificationCount({
                    publicUserId,
                  })
                );

                break;
              case 2:
                //  handleDraftChange("draftID", draftno);
                setDraft((prevState) => ({
                  ...prevState,
                  draftID: draftno,
                }));
                NotificationService({
                  title: currentLang?.Success,
                  message: currentLang?.DraftPopContent?.Draft_Updated_Success,
                  type: "success",
                });
                break;
              case -6:
                setIsPaymentMsg(true);
                setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
                break;
              default:
                break;
            }
          }
        }
      );

      return updatedDraft;
    });
  };

  // Known compound emojis that require special handling
  const compoundEmojis = ["🤷‍♀️", "🤷‍♂️"];

  // Regex to match both single emojis and compound emojis with ZWJ
  // const emojiRegex =    /(\p{Extended_Pictographic}(\u200D\p{Extended_Pictographic})*)/gu;
  const emojiRegex = commonemojiRegex();
  // Function to count emojis as single units and other characters normally
  // const getDisplayLength = useCallback(
  //   (text) => {
  //     // Count compound emojis explicitly
  //     let compoundEmojiCount = 0;
  //     compoundEmojis.forEach((emoji) => {
  //       const compoundRegex = new RegExp(emoji, "g");
  //       const match = text?.match(compoundRegex);
  //       if (match) {
  //         compoundEmojiCount += match?.length;
  //         // Remove matched compound emojis from text to prevent double-counting
  //         text = text.replace(compoundRegex, "");
  //       }
  //     });

  //     // Count remaining emojis with regex
  //     const matches = text?.match(emojiRegex);
  //     let emojiCount = matches ? matches.length : 0;

  //     // Calculate non-emoji characters
  //     let nonEmojiText = text?.replace(emojiRegex, "").normalize("NFC").trim();
  //     let nonEmojiCount = nonEmojiText?.length;

  //     // Total count: compound emojis + other emojis + non-emoji characters
  //     return parseInt(compoundEmojiCount + emojiCount + nonEmojiCount);
  //   },
  //   [] // Add any dependencies required
  // );

  const getDisplayLength = useCallback(
    (text) => {
      if (!text) return 0; // Handle undefined or null `text` input early

      let compoundEmojiCount = 0;
      let cleanedText = text;

      compoundEmojis.forEach((emoji) => {
        try {
          const compoundRegex = new RegExp(emoji, "g");
          const match = cleanedText?.match(compoundRegex);
          if (match) {
            compoundEmojiCount += match?.length;
            cleanedText = cleanedText.replace(compoundRegex, ""); // Remove compound emojis
          }
        } catch (e) {
          console.error(`Error processing compound emoji regex: ${emoji}`, e);
        }
      });

      // Count remaining emojis
      let emojiCount = 0;
      try {
        const matches = cleanedText?.match(emojiRegex);
        emojiCount = matches ? matches?.length : 0;
      } catch (e) {
        console.error(`Error processing emoji regex`, e);
      }

      // Calculate non-emoji characters
      let nonEmojiCount = 0;
      try {
        const nonEmojiText = cleanedText
          .replace(emojiRegex, "")
          .normalize("NFC")
          .trim();
        nonEmojiCount = nonEmojiText.length;
      } catch (e) {
        console.error(`Error processing non-emoji text`, e);
      }

      // Total count
      return compoundEmojiCount + emojiCount + nonEmojiCount;
    },
    [] // Add any dependencies required
  );

  // Function used for remove validation for particular field
  const removeFieldValidationByName = (fieldName) => {
    const field = document.querySelector(`[name="${fieldName}"]`);
    if (field && field.classList.contains("border-danger")) {
      field.classList.remove("border-danger");
    }
  };

  const findGraphemeClusters = (input) => {
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(input);
    let index = 0;
    const segments = graphemes.map(grapheme => {
      const segmentInfo = {
        segment: grapheme,
        index: index,
        input: input
      };
      index += grapheme.length;
      return segmentInfo;
    });

    return segments;
  };

  const handleInputClick = (e) => {
    const { target } = e;
    const inputValue = target.value;
    const caretPosition = target.selectionStart;
    const graphemes = findGraphemeClusters(inputValue);
    let graphemeIndex = 0;
    for (let i = 0; i < graphemes.length; i++) {
      if (graphemes[graphemes.length - 1].index < caretPosition) {
        graphemeIndex = caretPosition;
        break;
      }
      else if (graphemes[i].index == caretPosition) {
        graphemeIndex = i;
        break;
      }
    }
    setCursorPosition(graphemeIndex);
  };


  // Common onChange Event
  const handleChange = (e, isMessage) => {
    let { name, value, selectionStart, selectionEnd } = e.target;
    const prevValue = prevValueRef.current;
    const wasAdded = value.length > prevValue.length;
    const key = lastKeyRef.current;
    const currentAddValue = getDifference(value, prevValue);

    let chars = getGraphemes(currentAddValue);

    // Mobile Emoji Removed
    if (chars?.length == 1 && currentAddValue.match(emojiRegex)) {
      setMessage((prevState) => ({
        ...prevState,
        [name]: prevValue,
      }));
      return;
    }
    // Public User - Write Message / inbox / Archived - Unable to enter the emoji in between existing text
    // if (key !== "Backspace") {
    //   // 🔍 Detect the last typed character
    //   let lastTypedChar = "";
    //   if (wasAdded && selectionStart != null) {
    //     const insertedLength = value.length - prevValue.length;
    //     lastTypedChar = value.substring(selectionStart - insertedLength, selectionStart);
    //   }

    //   // Default to actual input caret if not passed
    //   const splitter = new GraphemeSplitter();
    //   const graphemes = splitter.splitGraphemes(prevValue);
    //   const updatedGraphemes = [
    //     ...graphemes.slice(0, cursorPosition),
    //     lastTypedChar,
    //     ...graphemes.slice(cursorPosition)
    //   ];
    //   const updatedValue = updatedGraphemes.join('');
    //   value = updatedValue;
    //   setCursorPosition(cursorPosition + 1);
    // }

    // // Get the last character typed
    // if (!isInsertingFromPicker.current && wasAdded) {
    //   const graphemes = getGraphemes(value);
    //   const lastChar = graphemes[graphemes.length - 1];

    //   // If the last character is an emoji, remove it
    //   if (isEmoji(lastChar)) {
    //     value = graphemes.slice(0, -1).join(""); // Remove last emoji
    //   }
    // }
    // // Always remove emojis that are not allowed
    // // value = removeUnallowedEmojis(value, emojiEnabled);
    removeFieldValidationByName(name);

    prevValueRef.current = value;

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Clear the specific field error
    }));

    if (name === "messageBody") {
      // Check if the length with emojis counted as single units is within the limit
      if (getDisplayLength(value) <= maxDescriptionLength) {
        setMessage((prevState) => ({
          ...prevState,
          [name]: value,
        }));

        setDraft((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        handleDraftChange("messageBody", value);
        handleDraftChange("subject", message?.subject);
        handleDraftChange("inmateID", message?.inmatesId);
        handleDraftChange("messageID", message?.MessageID);
        handleDraftChange("draftID", draft?.draftID);
        handleDraftChange("draftFromValue", draftFromValue);
        handleDraftChange("action", 0);
        setIsDraftModified(true);
        // if (isMessage) {
        //   handleDraftChange("messageBody",value)
        //   setIsDraftModified(true);
        // }
      }
    } else {
      value = value.trimStart();
      value = value.replace(/\s+/g, " ");
      setMessage((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      if (isMessage) {
        // handleDraftChange("subject",value)
      }
    }
  };

  // Handles the selection of an emoji, updates the corresponding field value,  ensures it does not exceed the maximum length, and refocuses the input field.
  // const handleEmojiSelect = (emoji, field) => {
  //   const maxLength = field === "messageBody" ? 2000 : 50; // Define the max length for each field

  //   setMessage((prevState) => {
  //     const newValue = prevState[field] + emoji; // Add emoji to the specified field

  //     // Ensure that the field value does not exceed the maximum length
  //     if (getDisplayLength(newValue) <= maxLength) {
  //       return {
  //         ...prevState,
  //         [field]: newValue,
  //       };
  //     }

  //     // If the value exceeds the maxLength, return the previous state
  //     return prevState;
  //   });

  //   // Assign to Draft State

  //   setDraft((prevState) => {
  //     const newValue = prevState[field] + emoji; // Add emoji to the specified field

  //     // Ensure that the field value does not exceed the maximum length
  //     if (getDisplayLength(newValue) <= maxLength) {
  //       return {
  //         ...prevState,
  //         [field]: newValue,
  //       };
  //     }

  //     // If the value exceeds the maxLength, return the previous state
  //     return prevState;
  //   });

  //   // Focus the appropriate input field after adding the emoji
  //   descInputRef.current.focus();
  // };
  const handleEmojiSelect = (emoji, field) => {
    const maxLength = field === "messageBody" ? 2000 : 50; // Define the max length for each field

    setMessage((prevState) => {
      const inputElement = descInputRef.current; // Reference to the input field
      const cursorPos = inputElement.selectionStart || 0; // Current cursor position
      const value = prevState[field] || ""; // Ensure the field value is not undefined

      // Insert emoji at the cursor position
      const newValue =
        value.slice(0, cursorPos) + emoji + value.slice(cursorPos);

      prevValueRef.current = newValue;

      // Ensure that the field value does not exceed the maximum length
      if (getDisplayLength(newValue) <= maxLength) {
        // Move the cursor position after the inserted emoji
        setTimeout(() => {
          inputElement.setSelectionRange(
            cursorPos + emoji.length,
            cursorPos + emoji.length
          );
          inputElement.focus();
        }, 0);
        handleDraftChange("messageBody", newValue);
        handleDraftChange("subject", message?.subject);
        handleDraftChange("inmateID", message?.inmatesId);
        handleDraftChange("messageID", message?.MessageID);
        handleDraftChange("draftID", draft?.draftID);
        handleDraftChange("draftFromValue", draftFromValue);
        handleDraftChange("action", 0);
        return {
          ...prevState,
          [field]: newValue,
        };
      }

      // If the value exceeds the maxLength, return the previous state
      return prevState;
    });

    // Assign to Draft State
    setDraft((prevState) => {
      const inputElement = descInputRef.current;
      const cursorPos = inputElement.selectionStart;
      const value = prevState[field] || "";

      const newValue =
        value.slice(0, cursorPos) + emoji + value.slice(cursorPos);

      if (getDisplayLength(newValue) <= maxLength) {
        return {
          ...prevState,
          [field]: newValue,
        };
      }

      return prevState;
    });
  };

  // Function used for calculate message cost and emoji cost
  const calculateMessageCost = useCallback((message, MsgCost, EmojiCost) => {


    // Match all valid emojis in the message
    const matches = checkEmojiRegex(message);

    // If no matches found, set costs to 0 and return early
    if (!matches) {
      setMessage((prevState) => ({
        ...prevState,
        //   messageCost: "0.00",
        messageEmojiCost: "0.00",
      }));
      // return;
    }

    // Use a Set to track unique emojis
    const uniqueEmojis = new Set(matches);

    // Calculate emoji costs
    const emojiCostTotal =
      uniqueEmojis.size *
      (EmojiCost || 0);
    const messageCost = MsgCost || 0;
    const totalCost = messageCost + emojiCostTotal;

    // Set state with formatted cost values
    setMessage((prevState) => ({
      ...prevState,
      messageCost: totalCost.toFixed(2),
      messageEmojiCost:
        emojiCostTotal.toFixed(2) !== 0 && emojiCostTotal.toFixed(2) !== null
          ? emojiCostTotal.toFixed(2)
          : "0.00",
      isEmojiUsed: emojiCostTotal > 0 ? true : false,
    }));
  },
    [PublicInboxMessageSubjectList, setMessage]
  );
  //  MulitcodFunction used for calculate message cost and emoji cost
  const multiCalCulateMessageCost = useCallback(
    (message) => {
      // Ensure PublicInboxMessageSubjectList is fresh
      const { FacilityEmojiCost, FacilityMessageCost } =
        PublicInboxMessageSubjectList || {};
      const compoundEmojiRegex =
        /👨‍👩‍👦‍👦|👨‍👩‍👧‍👦|👨‍👩‍👧‍👧|👨‍👩‍👦|👨‍👩‍👧|👩‍👧‍👦|👨‍👧‍👦|👩‍👦|👨‍👦|🤷‍♀️|🤷‍♂️|(?:[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F191}-\u{1F251}]|[\u{1F004}]|[\u{1F0CF}])/gu;

      const matches = message?.match(compoundEmojiRegex);

      // if (!matches) {
      //   return {
      //     totalCost: 0,
      //     emojiCostTotal: 0,
      //     messageCost: 0,
      //   };
      // }

      const uniqueEmojis = new Set(matches);
      const emojiCostTotal = uniqueEmojis.size * (FacilityEmojiCost || 0);
      const totalCost = (FacilityMessageCost || 0) + emojiCostTotal;

      return {
        totalCost: parseFloat(totalCost.toFixed(2)),
        emojiCostTotal: parseFloat(emojiCostTotal.toFixed(2)),
        messageCost: FacilityMessageCost,
      };
    },
    [PublicInboxMessageSubjectList]
  );

  // If Draft Message contains emoji but Admin Emoji access False means check through function
  const checkDraftContainsEmoji = async () => {
    try {
      const response = await dispatch(
        writeMessageActions.GetDraftMessageDetails({
          DraftID: messageDetails?.DraftID,
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        hideLoader();
        let status = response.payload;

        if (status.length > 0) {
          const messageBody = message?.messageBody;

          // Emoji check: if emojis are present and IsEmojiEnabled is false, show the popup
          var emojiRegex =
            /[\uD800-\uDBFF][\uDC00-\uDFFF]|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
          if (
            emojiRegex.test(messageBody) &&
            status[0].IsEmojiEnabled === false
          ) {
            setsendemonjiRectPopup(true);
            return false; // Return false if emojis are found and emoji is disabled
          } else {
            setsendemonjiRectPopup(false);
            return true; // Return true if no emojis are found or emoji is enabled
          }
        }
      }
      return true; // Default return if response is not fulfilled
    } catch (error) {
      console.error("Error checking draft emoji:", error);
      return true; // Return true in case of error
    }
  };

  const handleCancelMsgEmojiPermission = () => {
    setIsHasMsgEmojiPermission(false);
  };

  const handleKeyDown = (event) => {
    lastKeyRef.current = event.key;
    if (event.key === "Enter") {
      event.preventDefault();
      handleMessageSend();
    }
    if (event.key === "Meta") {
      // setDisableInput(true); // Disable input while the Windows key is held
      event.target.blur();
      event.target.blur();
    }
  };

  const handleKeyUp = () => { };

  const handleClickMsgEmojiPermission = () => {
    setMessage((prevState) => ({
      ...prevState,
      messageBody: "",
    }));
    setIsHasMsgEmojiPermission(false);
  };

  // Validates message fields, clears validation errors, and sets confirmation flags if no errors exist, calculating the message cost.
  const handleMessageSend = async (e) => {
    e?.preventDefault();
    setErrors({});
    setMessage((prevState) => ({
      ...prevState,
      draftID: draft?.draftID,
    }));
    if (messageDetails?.DraftID) {
      let draftEmoji = await checkDraftContainsEmoji(messageDetails?.DraftID);
      if (!draftEmoji) {
        return;
      }
    }

    if (document?.getElementsByClassName("border-danger").length !== 0) {
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
    }
    const { error } = writeMessageSchema(message);

    if (error?.details) {
      error.details.map((e) => {
        const { path } = e;

        // Update the errors state
        setErrors((prev) => ({
          ...prev,
          [path[0]]: e.message,
        }));

        // Select both input and textarea elements by name
        document
          .querySelector(`input[name=${path[0]}], textarea[name=${path[0]}]`)
          ?.classList.add("border-danger");
      });
      return;
    } else {
      showLoader();
      dispatch(
        myContactsActions.LoadPublicInmateByID({
          userID: userID,
          inmatesID: message.inmatesId,
          InmateLoadPurpose: "Message",
          ActiveStatus: 2,
          SortField: "",
        })
      ).then(async (response) => {
        hideLoader();
        const formatValue = response.payload[0];
        setPublicInboxMessageSubjectList((prevState) => ({
          ...prevState,
          CreditBalance: parseFloat(
            formatValue?.CreditBalance ? formatValue?.CreditBalance : 0
          ),
          FacilityMessageCost: parseFloat(
            formatValue?.FacilityMessageCost
              ? formatValue?.FacilityMessageCost
              : 0
          ),
          FacilityEmojiCost: parseFloat(
            formatValue?.IsEmojiEnabled ? formatValue?.FacilityEmojiCost : 0
          ),
        }));
        const messageCost =
          parseFloat(formatValue?.FacilityMessageCost ?? 0) +
          parseFloat(formatValue?.IsEmojiEnabled ? formatValue?.FacilityEmojiCost ?? 0 : 0);

        setMessage(prev => ({ ...prev, messageCost }));
        setIsEmojiEnable(formatValue?.IsEmojiEnabled === 1 ? true : false);

        //  check for restricted keywords
        const isAllowed = await checkRestrictedKeywords(message?.messageBody, formatValue?.facilityID);
        setMessage({ ...message, IsQuarantine: !isAllowed ? true : false })
        //if (!isAllowed) return;

        if (
          containsEmojis(message?.messageBody) &&
          formatValue?.IsEmojiEnabled === 0
        ) {
          setIsHasMsgEmojiPermission(true);
        } else {
          setIsHasMsgEmojiPermission(false);
          setSendMessageConfirmation(true);
          setShouldDisplayHTMLMessage(true);
          let text = message?.messageBody;
          const costDetails = calculateMessageCost(text, formatValue?.FacilityMessageCost ?? 0, formatValue?.IsEmojiEnabled ? formatValue?.FacilityEmojiCost ?? 0 : 0);
        }
      });
    }

    /* Event Log */
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup to send this message`,
      "---",
      "Are you sure you want to delete this conversation?",
      "Shows Yes or No Confirmation popup"
    );
  };

  const checkRestrictedKeywords = async (subject, facilityID) => {
    var result = await LoadQuarantineWords(subject, facilityID)
    if (result?.isQuarantineWords) {
      const restrictionMessage = `${currentLang?.Restricted_words} "${result?.keywordList}". ${currentLang?.Please_Remove}`;
      // setFoundKeyword(restrictionMessage);
      // setKeywordPopup(true);
      return false; //
    }
    else {
      setKeywordPopup(false);
      return true; // ✅ Proceed
    }
  };

  const containsEmojis = (str) => {
    // Matches emojis including `⭐` with or without variation selector
    const emojiRegex =
      /(?:[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{2B50}\u{FE0F}]|[\u{2B55}])/gu;

    return emojiRegex.test(str);
  };


  // Confirms message sending, shows a loader, dispatches the message action, and displays notifications based on the response status.
  const handleMessageSentConfirm = () => {
    // const updatedMessage = {
    //   ...message,
    //   messageCost: PublicInboxMessageSubjectList?.FacilityMessageCost,
    // };
    setSendMessageConfirmation(false);
    showLoader();
    const updatedMessage = {
      ...message, // Copy the current state
      draftID: draft?.draftID, // Update only the draftID
    };
    dispatch(
      writeMessageActions.InsertUpdateMessageCommunicationSent(updatedMessage)
    ).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();

        let status = response?.payload;
        message.result = response?.payload
        dispatch(writeMessageActions?.LoadSendNotificationandEmail(message));
        //Event log
        CreateEventLogTextFileForInbox(
          dispatch,
          `${currentMenuName} - Sent Reply Message ( Reply Message ID - ${location?.state?.messageID} ) `,
          "---",
          JSON.parse(status),
          `${status !== null
            ? `Message Sent Successfully. Return Value - ${status} `
            : `${status?.toString(status)}`
          }`
        );
        clearDraft();
        switch (status) {
          case -1:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Msg_Send_Failed,
              type: "warning",
            });
            break;
          case -2:
            prevValueRef.current = ""
            setMessage((prevState) => ({
              ...prevState,
              messageBody: "",
            }));
            setDraft((prevState) => ({
              ...prevState,
              messageBody: "",
              draftID: null,
            }));
            setMessageDetails((prevstate) => ({
              ...prevstate,
              messageBody: "",
              MessageBodyText: "",
            }));
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Repeated_Msg,
              type: "warning",
            });
            // Reload
            // loadMoreMessages(
            //   messageDetails?.MessageID,
            //   messageDetails?.PublicUserID,
            //   1,
            //   "save"
            // );
            setMessageDetails((prevstate) => ({
              ...prevstate,
              messageBody: "",
            }));

            break;
          case -3:
          case -5:
            setIsPaymentMsg(true);
            setPaymentMsg(currentLang?.InboxPopContent?.connection_Blocked);
            setIsMessageDisabled(true);
            setMessageDisabled(currentLang?.InboxPopContent?.No_longer_connected);
            setDisabledItems((prevstate) => ({
              ...prevstate,
              newMessage: true,
              messageHistory: false,
              purchaseCredits: true,
              cancelConnection: true,
              filterCODMessage: false,
              printMessage: false,
              deleteConversation: false,
            }));
            handleReset();
            break;
          case -6:
            setIsPaymentMsg(true);
            setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
            // setIsMessageDisabled(true);
            // setMessageDisabled("The Permission to send Message to this contact has been restricted. ");
            setDisabledItems((prevstate) => ({
              ...prevstate,
              newMessage: true,
              messageHistory: false,
              purchaseCredits: true,
              cancelConnection: false,
              filterCODMessage: false,
              printMessage: false,
              deleteConversation: true,
            }));
            setDeleteConversation(true);
            handleReset();
            break;
          case -7:
            setIsPaymentMsg(true);
            setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
            setIsMessageDisabled(true);
            setMessageDisabled(currentLang?.InboxPopContent?.No_Permission);
            setDisabledItems((prevstate) => ({
              ...prevstate,
              newMessage: true,
              messageHistory: false,
              purchaseCredits: true,
              cancelConnection: false,
              filterCODMessage: false,
              printMessage: false,
              deleteConversation: true,
            }));
            setDeleteConversation(true);
            handleReset();
            break;
          case -8:
            setIsPaymentMsg(true);
            setPaymentMsg(currentLang?.InboxPopContent?.No_longer_connected);
            setDisabledItems((prevstate) => ({
              ...prevstate,
              newMessage: true,
              messageHistory: false,
              purchaseCredits: true,
              cancelConnection: true,
              filterCODMessage: true,
              printMessage: false,
              deleteConversation: true,
            }));
            setDeleteConversation(true);
            handleReset();
            break;
          case -9:
            prevValueRef.current = ""
            NotificationService({
              title: currentLang?.Message,
              // message: "This message will be sent as COD.  It cannot be opened until credits are purchased or if the inmate chooses to use one of their free credits.",
              message: currentLang?.InboxPopContent?.Message_Send_Success,
              type: "success",
            });
            if (messageDetails?.DraftID) {
              const publicUserId = getStoredValue("userID");
              if (publicUserId) {
                dispatch(
                  archivedActions.PULoginUnreadNotificationCount({ publicUserId })
                );
              }
            }
            setisCreditamountModal(true);
            setMsgCreditamount(currentLang?.InboxPopContent?.Send_COD_Msg);
            handleReset();
            break;
          default:
            if (status > 0) {
              prevValueRef.current = ""
              // message?.messageBody ||
              // messageDetails?.MessageBody
              setMessage((prevState) => ({
                ...prevState,
                messageBody: "",
              }));
              setDraft((prevState) => ({
                ...prevState,
                messageBody: "",
                draftID: 0,
              }));
              setMessageDetails((prevstate) => ({
                ...prevstate,
                messageBody: "",
                MessageBodyText: "",
                DraftID: 0,
              }));
              // if (creditBalance?.CreditBalance === 0) {
              //   setShowCODPopup(true);
              // }
              NotificationService({
                title: currentLang?.Success,
                message: currentLang?.InboxPopContent?.Message_Send_Success,
                type: "success",
              });

              // loadMoreMessages(
              //   messageDetails?.MessageID,
              //   messageDetails?.PublicUserID,
              //   1,
              //   "save"
              // );
              setMessageDetails((prevstate) => ({
                ...prevstate,
                messageBody: "",
              }));

              // setDraftActive(false);
              // resetLocationState();
              // handleReset();
            }
            break;
        }
      }
    });
  };

  // Cancels the message send action by resetting the send confirmation state.
  const handleCancelMessage = () => {
    setSendMessageConfirmation(false);
    setCODApproveRejectMessage(false);
  };

  // reset message state
  const handleReset = () => {
    prevValueRef.current = ""
    setMessage((prevState) => ({
      ...prevState,
      messageBody: "",
    }));
    setDraft((prevState) => ({
      ...prevState,
      messageBody: "",
      draftID: 0,
    }));
    setMessageDetails((prevstate) => ({
      ...prevstate,
      messageBody: "",
      MessageBodyText: "",
      DraftID: 0,
    }));
  };

  const goBack = () => {
    const previousPath = location.state?.from;
    // Determine the fallback path
    const fallbackPath =
      previousPath === "/public/Archived"
        ? "/public/Archived"
        : "/public/Inbox";

    // Navigate to the fallback route and pass the state
    storeCurrentRoute(fallbackPath);
    navigate(fallbackPath, {
      state: {
        findInboxMessage: location.state?.findInboxMessage,
        pageNo: location.state?.pageNo,
        filteredArchieveMessageList:
          location.state?.filteredArchieveMessageList,
      },
    });
  };

  useEffect(() => {
    // Only execute the logic if the popup hasn't been shown yet
    if (!hasShownPopup.current && filteredMessageHistoryList?.length > 0) {
      const codMessage = filteredMessageHistoryList.find(
        (message) =>
          message.MessageStatus === "C.O.D Pending" &&
          !message?.IsSenderMsgDelete
      );
      hasShownPopup.current = true;

      if (codMessage) {
        setCODInfoPopup(true); // Show the popup
        hasShownPopup.current = true; // Mark as shown
      }
    }
  }, [filteredMessageHistoryList]);

  const handleCODInfoPopupClose = () => {
    setCODInfoPopup(false);
  };
  // MultiCOD Message Approve

  const handleMultiApproveCODMessage = () => {
    const templateArray = [
      {
        msgID: null,
        delInID: null,
        codMsgID: null,
        codPublicUserID: message.userID,
        codInmateID: message.inmatesId,
        codFacilityID: message.facilityID,
        codDebitCostOfFacility: null,
        coDmsgSender: "PublicUser",
        codMainMesgID: message.replyMessageID,
      },
    ];

    // Create a copy of the templateArray (if needed)
    const updatedArray = [...templateArray];

    // Process `isCheckboxChecked`
    const result = Object.entries(isCheckboxChecked)
      .filter(([key, value]) => value.checked) // Filter only checked items
      .map(([key, value]) => {
        // Clone the template object to avoid mutating the original
        const newObject = { ...updatedArray[0] }; // Using the first object from the templateArray
        newObject.codMsgID = key; // Assign the key (e.g., 53287) to msgID
        newObject.codDebitCostOfFacility = value.messageCost; // Assign messageCost to codDebitCostOfFacility
        return newObject;
      });

    const formData = {
      Rows: result?.length,
      actionType: 0,
      publicUserId: userID,
      UserProfiles: result,
    };

    if (PublicInboxMessageSubjectList?.CreditBalance >= message.messageCost) {
      dispatch(inboxActions.MultiUpdateCODMessage(formData)).then(
        (response) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            const status = response?.payload;
            switch (status) {
              case 1:
                NotificationService({
                  title: currentLang?.Success,
                  message: currentLang?.InboxPopContent?.Msg_Approved_Success,
                  type: "success",
                });

                //handleMultiCancelMessages();
                setFilterStatusResponse(true);
                // loadMoreMessages(
                //   messageDetails?.MessageID,
                //   messageDetails?.PublicUserID,
                //   1,
                //   "save"
                // );

                setMessage((prevState) => ({
                  ...prevState,
                  messageBody: "",
                }));
                setDraft((prevState) => ({
                  ...prevState,
                  messageBody: "",
                  draftID: 0,
                }));
                setMessageDetails((prevstate) => ({
                  ...prevstate,
                  messageBody: "",
                  MessageBodyText: "",
                  DraftID: 0,
                }));

                break;
              case -1:
                NotificationService({
                  title: currentLang?.Warning,
                  message: currentLang?.InboxPopContent?.Low_balance,
                  type: "warning",
                });
                break;
              case -2:
                NotificationService({
                  title: currentLang?.Warning,
                  message: currentLang?.InboxPopContent?.Low_balance,
                  type: "warning",
                });
                break;
              case -3:
                NotificationService({
                  title: currentLang?.Warning,
                  message: currentLang?.InboxPopContent?.Something_went_wrong,
                  type: "warning",
                });
                break;
              case -4:
                NotificationService({
                  title: currentLang?.Warning,
                  message: currentLang?.InboxPopContent?.Not_Approved,
                  type: "warning",
                });
                break;
              default:
                NotificationService({
                  title: currentLang?.Warning,
                  message: currentLang?.InboxPopContent?.Something_went_wrong,
                  type: "warning",
                });
            }
          }
        }
      );
    } else {
      NotificationService({
        title: currentLang?.Warning,
        message: currentLang?.InboxPopContent?.Low_balance,
        type: "warning",
      });
    }
    setMultiCODPopup(false);
  };

  const handleMultiRejectCODMessage = () => {
    const templateArray = [
      {
        msgID: null,
        delInID: null,
        codMsgID: null,
        codPublicUserID: message.userID,
        codInmateID: message.inmatesId,
        codFacilityID: message.facilityID,
        codDebitCostOfFacility: null,
        coDmsgSender: "PublicUser",
        codMainMesgID: message.replyMessageID,
      },
    ];

    // Create a copy of the templateArray (if needed)
    const updatedArray = [...templateArray];

    // Process `isCheckboxChecked`
    const result = Object.entries(isCheckboxChecked)
      .filter(([key, value]) => value.checked) // Filter only checked items
      .map(([key, value]) => {
        // Clone the template object to avoid mutating the original
        const newObject = { ...updatedArray[0] }; // Using the first object from the templateArray
        newObject.codMsgID = key; // Assign the key (e.g., 53287) to msgID
        newObject.codDebitCostOfFacility = value.messageCost; // Assign messageCost to codDebitCostOfFacility
        return newObject;
      });

    const formData = {
      Rows: result?.length,
      actionType: 1,
      publicUserId: userID,
      UserProfiles: result,
    };

    dispatch(inboxActions.MultiUpdateCODMessage(formData)).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        const status = response?.payload;
        switch (status) {
          case 1:
            NotificationService({
              title: currentLang?.Success,
              message: currentLang?.InboxPopContent?.Msg_Rejected_Success,
              type: "success",
            });
            loadMoreMessages(
              messageDetails?.MessageID,
              messageDetails?.PublicUserID,
              1,
              "save"
            );
            //handleMultiCancelMessages();
            setFilterStatusResponse(true);
            break;
          case -1:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Low_balance,
              type: "warning",
            });
            break;
          case -2:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Low_balance,
              type: "warning",
            });
            break;
          case -3:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Something_went_wrong,
              type: "warning",
            });
            break;
          case -4:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Not_Approved,
              type: "warning",
            });
            break;
          default:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Something_went_wrong,
              type: "warning",
            });
            break;
        }
      }
    });

    setMultiCODPopupReject(false);
  };

  // COD Message Approve
  const handleApproveCODMessage = () => {
    showLoader();
    // Dispatch draft message action with updated draft
    let data = {
      inmateId: parseInt(message?.inmatesId),
      messageId: parseInt(messageDetails?.MessageID),
    };
    if (PublicInboxMessageSubjectList?.CreditBalance < message?.messageCost) {
      hideLoader();
      NotificationService({
        title: currentLang?.Warning,
        message: currentLang?.InboxPopContent?.Low_balance,
        type: "warning",
      });
    } else {
      dispatch(inboxActions.LockdownPODRestriction(data)).then((response) => {
        hideLoader();
        if (response?.meta?.requestStatus === "fulfilled") {
          const status = response?.payload;
          var logStatus =
            "The Permission to send Message to this contact has been restricted. ";
          switch (status) {
            case 1:
              if (
                PublicInboxMessageSubjectList?.CreditBalance >=
                PublicInboxMessageSubjectList?.FacilityMessageCost
              ) {
                var msgbody = filteredMessageHistoryList?.find((x) => (x?.MessageID == codMessageID));
                const formData = {
                  typMessagePhotoPendingLists: [
                    {
                      messageId: codMessageID,
                      publicUserID: userID,
                      facilityID: message?.facilityID,
                      inmateID: message?.inmatesId,
                      convoType: 0,
                      messageConversationID: messageDetails?.MessageID,
                      senderType: "PublicUser",
                      actionType: 0,
                    }
                  ],
                  messagetxt: msgbody?.MessageBody || msgbody?.MessageBodyText
                };
                dispatch(inboxActions.MessagePhotoCODClear(formData)).then(
                  (response) => {
                    if (response?.meta?.requestStatus === "fulfilled") {
                      const status = response?.payload;
                      switch (status) {
                        case 1:
                          if (
                            PublicInboxMessageSubjectList?.CreditBalance >=
                            PublicInboxMessageSubjectList?.FacilityMessageCost
                          ) {
                            NotificationService({
                              title: currentLang?.Success,
                              message: currentLang?.InboxPopContent?.COD_Approved_Sucess,
                              type: "success",
                            });
                            logStatus = "COD Message Approved Successfully";
                            setMessage((prevState) => ({
                              ...prevState,
                              messageBody: "",
                            }));
                            setDraft((prevState) => ({
                              ...prevState,
                              messageBody: "",
                              draftID: 0,
                            }));
                            setMessageDetails((prevstate) => ({
                              ...prevstate,
                              messageBody: "",
                              MessageBodyText: "",
                              DraftID: 0,
                            }));
                            // loadMoreMessages(
                            //   messageDetails?.MessageID,
                            //   messageDetails?.PublicUserID,
                            //   1,
                            //   "save"
                            // );
                          } else {
                            NotificationService({
                              title: currentLang?.Warning,
                              message: currentLang?.InboxPopContent?.Low_balance,
                              type: "warning",
                            });
                          }
                          break;
                        case -1:
                        case -2:
                          NotificationService({
                            title: currentLang?.Warning,
                            message: currentLang?.InboxPopContent?.Low_balance,
                            type: "warning",
                          });
                          logStatus = "Credit Balance Low";
                          break;
                        default:
                          NotificationService({
                            title: currentLang?.Warning,
                            message: currentLang?.InboxPopContent?.Something_went_wrong,
                            type: "warning",
                          });
                          break;
                      }
                    }
                  }
                );
              } else {
                NotificationService({
                  title: currentLang?.Message,
                  message: currentLang?.InboxPopContent?.Low_balance,
                  type: "warning",
                });
                logStatus = "Credit Balance Low";
              }
              break;
            default:
              NotificationService({
                title: currentLang?.Message,
                message: currentLang?.InboxPopContent?.No_Permission,
                type: "warning",
              });
              break;
          }

          /* Event Log */
          CreateEventLogTextFileForInbox(
            dispatch,
            `Approve COD Message ( Message ID - ${location?.state?.messageID} ) `,
            "---",
            "Message - Approved successfully..!",
            logStatus
          );
        }
      });
    }

    setCODApproveRejectMessage(false);
  };

  // COD Message reject
  const handleRejectCODMessage = () => {
    showLoader();
    // Dispatch draft message action with updated draft
    let data = {
      inmateId: message?.inmatesId,
      messageId: messageDetails?.MessageID,
    };
    dispatch(inboxActions.LockdownPODRestriction(data)).then((response) => {
      hideLoader();
      if (response?.meta?.requestStatus === "fulfilled") {
        const status = response?.payload;

        /* Event Log */
        CreateEventLogTextFileForInbox(
          dispatch,
          `Reject COD Message ( Message ID - ${location?.state?.messageID} ) `,
          "---",
          "---",
          `${status > 0
            ? ` COD Message Rejected Successfully`
            : `Something went wrong`
          }`
        );
        switch (status) {
          case 1:
            const formData = {
              typMessagePhotoPendingLists: [
                {
                  messageId: codMessageID,
                  publicUserID: userID,
                  facilityID: message?.facilityID,
                  inmateID: message?.inmatesId,
                  convoType: 0,
                  messageConversationID: messageDetails?.MessageID,
                  senderType: "PublicUser",
                  actionType: 1,
                },
              ],
              messagetxt: message?.messageBody
            };
            dispatch(inboxActions.MessagePhotoCODClear(formData)).then(
              (response) => {
                if (response?.meta?.requestStatus === "fulfilled") {
                  const status = response?.payload;
                  switch (status) {
                    case 1:
                      NotificationService({
                        title: currentLang?.Message,
                        message: currentLang?.InboxPopContent?.Msg_Rejected_Success,
                        type: "Success",
                      });
                      const MessageID = codMessageID;
                      const PublicUserID = publicUserId;
                      dispatch(inboxActions.LoadPublicInboxMessageSubject({ MessageID, PublicUserID })).then((x => {
                        if (publicUserId) {
                          dispatch(archivedActions.PULoginUnreadNotificationCount({ publicUserId }));
                        }
                      }))
                      loadMoreMessages(
                        messageDetails?.MessageID,
                        messageDetails?.PublicUserID,
                        1,
                        "save"
                      );

                      break;
                    case -1:
                      NotificationService({
                        title: currentLang?.Warning,
                        message: currentLang?.InboxPopContent?.Low_balance,
                        type: "warning",
                      });
                      break;
                    default:
                      NotificationService({
                        title: currentLang?.Warning,
                        message: currentLang?.InboxPopContent?.Something_went_wrong,
                        type: "warning",
                      });
                      break;
                  }
                }
              }
            );
            break;
          default:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.No_Permission,
              type: "warning",
            });
            break;
        }
      }
    });

    setCODApproveRejectMessage(false);
  };

  // Redirect Into WriteMessage Page
  const handleClickNewMessage = () => {
    showLoader();
    dispatch(
      sendPhotosActions.LoadPublicInmateConnectionDet({
        userID: userID,
        inmatesID: message?.inmatesId,
      })
    );
    hideLoader();
    CreateEventLogTextFileForInbox(
      dispatch,
      `Redirect into Write Message page to sent New Message ( - "${location.state?.inmateID}") `,
      "public/WriteMessage",
      "---",
      "---"
    );
  };

  // Redirect Into Inbox List Page
  const handleNavigateInboxHistory = () => {
    const previousPath = location.state?.from;

    const updatedInboxMessage = {
      ...location.state?.findInboxMessage, // Spread current `findPhotos` to retain existing values
      InmateID: message?.inmatesId,
    };

    const fallbackPath =
      previousPath === "/public/Archived"
        ? "/public/Archived"
        : "/public/Inbox";

    storeCurrentRoute(fallbackPath);
    // Navigate to the fallback route and pass the state
    navigate(fallbackPath, {
      state: {
        findInboxMessage: updatedInboxMessage,
        pageNo: location.state?.pageNo,
        filteredArchieveMessageList:
          location.state?.filteredArchieveMessageList,
      },
    });
  };

  // PurchaseCredit Redirect
  const handleClickRedirectPurchaseCredit = (event, InmateID) => {
    event.stopPropagation(); // Prevent event from bubbling up
    setisCreditamountModal(false);
    showLoader();
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: {
          UserID: parseInt(userID),
          InmateID: parseInt(message?.inmatesId),
        },
      })
    );
    hideLoader();

    CreateEventLogTextFileForInbox(
      dispatch,
      `Redirect into Purchase Credits page to Purchase Credits for Inmate ( Inmate ID - " ${location.state?.inmateID} " ) `,
      "/public/PurchaseCredits",
      "---",
      "---"
    );
  };

  // Function to handle clicks outside the emoji picker
  const handleClickOutside = (event) => {
    // Check if the emoji picker is mounted and the click target is outside of it
    if (
      emojiPickerRef.current &&
      !emojiPickerRef.current.contains(event.target)
    ) {
      setIsDescIconPickerOpen(false); // Close the description emoji picker if click is outside
    }
  };

  useEffect(() => {
    // If the description emoji picker is open, attach the event listener to detect outside clicks
    if (isDescIconPickerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      // If picker is not open, ensure the event listener is removed
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup: remove the event listener when the component unmounts or the dependency changes
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDescIconPickerOpen]); // Run this effect whenever the picker open state changes

  const handleClickUpdateConnection = () => {
    dispatch(
      sendPhotosActions.UpdateInmateConnection({
        PUIConnectionID: messageDetails?.PUIConnectionID
          ? messageDetails?.PUIConnectionID
          : PUIConnectionID,
        UserID: parseInt(userID),
        InmatesId: message?.inmatesId,
        FacilityID: message?.facilityID,
        RequestChangeUser: "PublicUser",
        ToConnectionStatusID: 3,
        Action: 0,
        IsSALoginAsPU: 0,
        InmateResidentID: "",
        RelationShip: "",
        InmateInvitePublicUserID: parseInt(userID),
      })
    )
      .then((result) => {
        const res = result?.payload;
        CreateEventLogTextFileForInbox(
          dispatch,
          `Cancel Public User - Inmate Connection ( PUIConnectionID - "${location.state?.PUIConnectionID}" ) `,
          "---",
          "---",
          `${res === 1
            ? "Request Canceled  successfully"
            : res === -1
              ? "Operation Failed"
              : res === -2
                ? "Current Connection Status is Not Request Rejected By Inmate"
                : res === -3
                  ? "Current Connection Status is Not Request Accept By Inmate"
                  : res === -4
                    ? "Current Connection Status is Not Request Cancel By Public User"
                    : res === -5
                      ? "Current Connection Status is Not Request Accept By Public User"
                      : res === -6
                        ? "The Inmate Connection Limit Exceeded"
                        : ""
          }`
        );
      })
      .catch((err) => {
        console.error("Failed to create log");
      });

    // When COD filter is not active, filter out certain messages
    const filteredMessages = filteredMessageHistoryList.filter(
      (message, index) => {
        // Exclude the last index value
        if (index === filteredMessageHistoryList.length - 1) {
          return false;
        }

        // Apply the condition for other messages
        return (
          message.Sender === "Inmate" && message.IsSenderMsgDelete === false
        );
      }
    );

    if (filteredMessages.length > 0) {
      // If there are valid messages, enable deleteConversation
      setDisabledItems((prevState) => ({
        ...prevState,
        deleteConversation: false,
      }));
    } else {
      // If no valid messages exist, disable deleteConversation
      setDisabledItems((prevState) => ({
        ...prevState,
        deleteConversation: true,
      }));
    }

    // setDisabledItems((prevState) => ({
    //   ...prevState,
    //   deleteConversation: true, // Force disable
    // }));

    setCancelConnectionPopup(false);

    CreateEventLogTextFileForInbox(
      dispatch,
      `Cancel Public User - Inmate Connection ( PUIConnectionID - "${location.state?.PUIConnectionID}" ) `,
      "---",
      "---",
      `${UpdateInmateConnectionResponse === 1
        ? "Request Canceled  successfully"
        : UpdateInmateConnectionResponse === -1
          ? "Operation Failed"
          : UpdateInmateConnectionResponse === -2
            ? "Current Connection Status is Not Request Rejected By Inmate"
            : UpdateInmateConnectionResponse === -3
              ? "Current Connection Status is Not Request Accept By Inmate"
              : UpdateInmateConnectionResponse === -4
                ? "Current Connection Status is Not Request Cancel By Public User"
                : UpdateInmateConnectionResponse === -5
                  ? "Current Connection Status is Not Request Accept By Public User"
                  : UpdateInmateConnectionResponse === -6
                    ? "The Inmate Connection Limit Exceeded"
                    : ""
      }`
    );
  };

  const handleMultiDeleteClick = () => {
    setMultiDeleteMenuActive(!multiDeleteMenuActive);
    setSelectedDeleteMessages([]);

    if (!multiDeleteMenuActive) {
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Delete Message in Chat History (Message ID - ${location?.state?.MessageID} `,
        "---",
        "---",
        "Going to Delete Messages in this chat"
      );
    } else {
      CreateEventLogTextFileForInbox(
        dispatch,
        `${currentMenuName} - Undo Delete Message in Chat History (Message ID - ${location?.state?.MessageID} `,
        "---",
        "---",
        "Show Messages"
      );
    }
  };

  // Function to handle "Select All" checkbox change
  const handleSelectAllDeleteChange = () => {
    setSelectedDeleteMessages((prevSelectedDeleteMessages) => {
      const inmateMessageIDs = filteredMessageHistoryList
        .slice(0, filteredMessageHistoryList.length - 1) // Exclude the last message
        .filter((message) => message.Sender === "Inmate") // Filter messages from "Inmate"
        .map((message) => message.MessageID); // Map to MessageID

      if (prevSelectedDeleteMessages.length === inmateMessageIDs.length) {
        // If all filtered "Inmate" messages are selected, deselect all
        return [];
      } else {
        // Select all filtered "Inmate" messages
        return inmateMessageIDs;
      }
    });
  };

  const handleMultiDeleteMessages = () => {
    setMultiDeleteConfirmation(true);
  };

  // Multi Delete Cancel Click
  const handleMultiDeleteCancelMessages = () => {
    setSelectedDeleteMessages([]);
  };

  // Multi Delete Confirm to delete click Function
  const handleMultiDeleteConfirmClick = () => {
    const assignMessageIDs = (selectedDeleteMessages, templateArray) => {
      // Clone the template array to avoid mutating the original
      const updatedArray = [...templateArray];

      // Map over the selectedDeleteMessages and dynamically assign msgID
      const result = selectedDeleteMessages.map((messageID, index) => {
        // Clone the template object to avoid mutating the original
        const newObject = { ...updatedArray[0] }; // Assuming all objects are based on the first object in the array
        newObject.msgID = messageID; // Assign msgID dynamically
        return newObject;
      });

      return result;
    };

    // Example Usage:

    const templateArray = [
      {
        msgID: "string",
        delInID: userID,
        codMsgID: null,
        codPublicUserID: null,
        codInmateID: null,
        codFacilityID: null,
        codDebitCostOfFacility: null,
        coDmsgSender: null,
        codMainMesgID: null,
      },
    ];

    const updatedArray = assignMessageIDs(
      selectedDeleteMessages,
      templateArray
    );

    // Form the payload to match the required API structure
    const data = {
      rows: updatedArray?.length, // Set the appropriate value for 'rows'
      actionType: null, // Set the appropriate action type
      publicUserId: userID, // Set the appropriate public user ID
      userProfiles: updatedArray || [], // Assign the updatedArray to userProfiles
    };
    const filteredMessages = filteredMessageHistoryList.filter(
      (message) =>
        message?.MessageID !== messageDetails?.MessageID &&
        !selectedDeleteMessages.includes(message?.MessageID)
    );

    dispatch(inboxActions.MultiDeleteMessage(data)).then((response) => {
      hideLoader();
      setMultiDeleteConfirmation(false);
      if (response?.meta?.requestStatus === "fulfilled") {
        const status = response?.payload;
        switch (status) {
          case 1:
            NotificationService({
              title: currentLang?.Message,
              message: currentLang?.InboxPopContent?.Msg_Deleted_Success,
              type: "Success",
            });
            setMessageDetails((prevstate) => ({
              ...prevstate,
              MessageID: filteredMessages[0].MessageID,
            }));
            setDisabledItems((prevState) => ({
              ...prevState, // spread the previous state
              deleteConversation: false, // set deleteConversation to true
            }));
            setMultiDeleteMenuActive(false);
            handleMultiDeleteCancelMessages();
            break;

          default:
            NotificationService({
              title: currentLang?.Message,
              message: currentLang?.InboxPopContent?.Msg_Deleted_Failed,
              type: "Success",
            });
            break;
        }
      }
    });
  };

  const handlePrintShow = (row) => {
    const RowData = row;

    setisPrintData(true);
    setTimeout(() => {
      handlePrints();
    }, 50);
    setTimeout(() => {
      setisPrintData(false);
    }, 1000);

    setColumnOrderData(RowData);

    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Clicked Print Message button (Message ID - ${location?.state?.MessageID} )`,
      "---",
      "---",
      "Print Message Conversation"
    );
  };

  const pageStyle = useMemo(
    () => `
  @media print {
    @page {
      margin: 10mm;
    }

    body {
      -webkit-print-color-adjust: exact;
      margin: 0;
      padding: 0;
    }

    .message-box {
      /* Allow breaking if it’s too long to avoid blank space */
      page-break-inside: auto;
      break-inside: auto;
      margin-bottom: 10px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      /* allow table to split if needed */
      page-break-inside: auto;
      break-inside: auto;
    }

    tr, td, th {
      page-break-inside: auto;
      break-inside: auto;
      word-wrap: break-word;
      white-space: pre-wrap;
      vertical-align: top;
      font-size: 14px;
      padding: 6px;
      border: 1px solid black;
    }

    h4 {
      text-align: center;
      margin-bottom: 10px;
    }

    .message-container {
      margin: 0;
      padding: 0;
    }
  }
`,
    []
  );

  const handlePrints = useReactToPrint({
    pageStyle,
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(resolve, 50); // Allow content to render
      });
    },
    onAfterPrint: () => {
    },
  });

  // const handlePrints = useReactToPrint({
  //   pageStyle,
  //   content: () => componentRef.current,
  //   onBeforeGetContent: () => {},
  // });

  // const handlePrints = useReactToPrint({
  //   pageStyle: `
  //     @media print {
  //       @page {
  //         size: auto;
  //         margin: 10mm; /* Adjust margins as needed */
  //       }
  //       body {
  //         -webkit-print-color-adjust: exact; /* Ensures color printing */
  //       }
  //       table {
  //         width: 100%;
  //         border-collapse: collapse; /* Prevent gaps in table borders */
  //         page-break-inside: avoid;
  //       }
  //       tr {
  //         page-break-inside: avoid; /* Prevent table rows from splitting */
  //       }
  //       .message-box {
  //         page-break-inside: avoid; /* Ensure message containers stay together */
  //         page-break-after: auto; /* Prevent breaking between containers unnecessarily */
  //       }
  //       .message-container {
  //         margin-bottom: 20px; /* Space between tables */
  //       }
  //     }
  //   `,
  //   content: () => componentRef.current,
  //   onBeforeGetContent: () => { },

  // });

  const handleClickDeleteConfiramtion = (messageID) => {
    setDeleteMessageID(messageID);
    setDeleteMessagePopup(true);

    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup to Delete this conversation`,
      "---",
      "Are you sure you want to delete this conversation?",
      "Shows Yes or No Confirmation popup"
    );
  };

  const handleDeleteMessageClick = () => {
    setDeleteMessagePopup(false);
    if (deleteMessageID) {
      showLoader();
      // Dispatch draft message action with updated draft
      let data = {
        userId: userID,
        messageId: deleteMessageID,
        facilityID: message?.facilityID,
      };
      const filteredMessages = filteredMessageHistoryList.filter(
        (message) => message?.MessageID !== deleteMessageID
      );
      dispatch(inboxActions.InsertUpdatePublicInboxMessageDelete(data)).then(
        (response) => {
          hideLoader();
          if (response?.meta?.requestStatus === "fulfilled") {
            const status = response?.payload;
            CreateEventLogTextFileForInbox(
              dispatch,
              `${currentMenuName} - Delete Message (Message ID - ${location?.state?.MessageID})`,
              status,
              "---",
              "Message Deleted successfully"
            );
            switch (status) {
              case 1:
                NotificationService({
                  title: currentLang?.Message,
                  message: currentLang?.InboxPopContent?.Msg_Deleted_Success,
                  type: "Success",
                });

                // loadMoreMessages(
                //   messageDetails?.MessageID,
                //   messageDetails?.PublicUserID,
                //   1,
                //   "save"
                // );

                setMessageDetails((prevstate) => ({
                  ...prevstate,
                  MessageID: filteredMessages[0].MessageID,
                }));
                setDisabledItems((prevState) => ({
                  ...prevState, // spread the previous state
                  deleteConversation: true, // set deleteConversation to true
                }));
                setDeleteConversation(true);
                setMultiDeleteMenuActive(false);
                handleMultiDeleteCancelMessages();

                break;

              default:
                NotificationService({
                  title: currentLang?.Message,
                  message: currentLang?.InboxPopContent?.Msg_Deleted_Failed,
                  type: "Success",
                });
                break;
            }
          }
        }
      );
      setDeleteMessageID(null);
    }
  };
  // Function to handle checkbox toggle
  // const handleCheckboxChange = (e, messageId, messageSubjectText, FacilityMessageCost) => {
  //   const { checked } = e.target;
  //   setIsCheckboxChecked((prev) => ({
  //     ...prev,
  //     [messageId]: checked, // Update the checked status
  //       subject: messageSubjectText,
  //       messageCost: FacilityMessageCost // Maintain the subject text
  //   }));
  // };

  // Function to handle checkbox change (select or deselect a message) - Multi Delete
  const handleMultiDeleteCheckboxChange = (messageID) => {
    setSelectedDeleteMessages((prevSelectedDeleteMessages) => {
      // Check if the message is already in the selected list
      if (prevSelectedDeleteMessages.includes(messageID)) {
        // If the message is already selected, remove it from the list (deselect)
        return prevSelectedDeleteMessages.filter((id) => id !== messageID);
      } else {
        // If the message is not selected, add it to the list (select)
        return [...prevSelectedDeleteMessages, messageID];
      }
    });
  };

  // Handle "Select All" checkbox
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);

  // Multi COD Single Selecttion
  const handleCheckboxChange = (
    e,
    messageId,
    messageSubjectText,
    FacilityMessageCost,
    message
  ) => {
    const { checked } = e.target;
    setIsCheckboxChecked((prev) => {
      const updatedState = {
        ...prev,
        [messageId]: {
          checked,
          subject: messageSubjectText,
          messageCost: FacilityMessageCost,
          message: message,
        },
      };

      if (!checked) {
        delete updatedState[messageId];
      }

      // Check if all individual checkboxes are selected
      const filteredMessages = filteredMessageHistoryList.filter(
        (message) =>
          message?.MessageStatus === "C.O.D Pending" &&
          !message?.IsSenderMsgDelete
      );
      const allSelected = filteredMessages.every(
        (message) => updatedState[message.MessageID]?.checked
      );

      // Update "Select All" checkbox state
      setIsSelectAllChecked(allSelected);

      if (Object.keys(updatedState).length === 0) {
        return {};
      }

      return updatedState;
    });
  };

  // Multi - COD Select All option ------------------------------------
  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setIsSelectAllChecked(checked);

    if (checked) {
      // Filter messages for COD Pending and not deleted
      const filteredMessages = filteredMessageHistoryList.filter(
        (message) =>
          message?.MessageStatus === "C.O.D Pending" &&
          !message?.IsSenderMsgDelete
      );

      // Update all checkboxes
      const updatedCheckedMessages = {};
      filteredMessages.forEach((message) => {
        updatedCheckedMessages[message.MessageID] = {
          checked: true,
          subject: message?.subject,
          messageCost: message?.DebitCostOfFacility ?? 0,
          message: message,
        };
      });
      setIsCheckboxChecked(updatedCheckedMessages);
    } else {
      // Deselect all
      setIsCheckboxChecked({});
    }
  };

  const handleMultiCancelMessages = () => {
    setIsCheckboxChecked([]);
    const filteredMessages = filteredMessageHistoryList.filter(
      (message) =>
        message?.MessageStatus === "C.O.D Pending" &&
        message?.IsSenderMsgDelete === false
    );
    if (filteredMessages?.length === 0) {
      setShowCheckbox(false);
    } else {
      setShowCheckbox(true);
    }
    setIsSelectAllChecked(false);
    setFilterStatusResponse(false);
  };


  const handleQuickMenu = () => {
    if (!disabledItems?.newMessage) {
      setNewMessage(true);
    }
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup to Redirect Write message page`,
      "---",
      "This action redirects into another page, Are you sure you want to proceed?",
      "Shows Yes or No Confirmation popup"
    );
  };

  const handlePurchaseCreditQuickMenu = () => {
    if (!disabledItems?.purchaseCredits) {
      setPurchaseCreditPopup(true);
    }

    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup to Purchase Credit ( Inmate ID - " ${location?.state?.inmateID} " ) `,
      "---",
      "This action redirects into another page, Are you sure you want to proceed?",
      "Shows YES or No Confirmation popup"
    );
  };

  const handleCancelConnection = () => {
    if (!disabledItems?.cancelConnection) {
      setCancelConnectionPopup(true);
    }

    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} - Show Confirmation Message Popup to Cancel Connection Request`,
      "---",
      "---",
      "Shows YES or No Confirmation popup"
    );
  };

  const handleClose = () => {
    setNewMessage(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} -  Clicked NO option In Redirect into Write Message confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handlePurchaseCreditPopupClose = () => {
    setPurchaseCreditPopup(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} -  Clicked NO option In Redirect into Purchase Credit confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handleCancelConnectionPopupClose = () => {
    setCancelConnectionPopup(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} -  Clicked NO option Cancel Connection confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handleSingleDelete = () => {
    setDeleteMessagePopup(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `${currentMenuName} -  Clicked NO option Cancel Connection confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  return (
    <>
      <ReactNotifications />
      <div className="">
        <div className="row mb-4 pb-mobile">
          {/* -------------------- Center Section - Chat Area & Emoji ----------------------------- */}
          <div className="col-12 col-lg-8">
            <div className="messenger-content shadow-sm mb-3">
              <div className="widget-chat border-radius-all">
                {/* Chat Area - Header Section */}
                <div className="widget-chat-header mt-1">
                  <button
                    type="button"
                    className="btn border-0 shadow-none"
                    data-toggle-class="messenger-chat-content-mobile-toggled"
                    data-target="#messenger"
                    onClick={() => goBack()}
                  >
                    <i className="fa fa-chevron-left fa-lg"></i>
                  </button>
                  <div className="widget-chat-header-content">
                    <div className="d-flex align-items-center">
                      <i
                        className="fa fa-user-circle fa-2x me-3"
                        aria-hidden="true"
                        style={{ paddingTop: "" }}
                      ></i>
                      <div>
                        <div className="font-size-16 fw-700">
                          {PublicInboxMessageSubjectList?.InmateFullName ||
                            "Inmate Name"}
                        </div>
                        <div className="fs-5">
                          {currentLang?.inbox?.Subject} :{" "}
                          {PublicInboxMessageSubjectList?.MessageSubjectText ||
                            "No Subject"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 position-relative">
                      <input
                        type="text"
                        className="form-control border-0 bg-light pl-3"
                        placeholder={currentLang?.placeholders?.txtSearch}
                        value={searchHistoryList}
                        onChange={(e) => setSearchHistoryList(e.target.value)}
                      />
                      <i className="fa fa-search position-absolute top-50 start-0 translate-middle-y pl-15 me-1"></i>
                    </div>
                  </div>
                </div>

                {/*---------------------------- Chat Area - Body (Messages show section) -------------------------- */}

                <div
                  className="widget-chat-body overflow-auto"
                  style={{
                    maxHeight: "370px",
                    position: "relative",
                    minHeight: "350px",
                  }}
                  ref={chatContainerRef}
                  onScroll={handleScroll}
                >
                  {filteredMessageHistoryList &&
                    filteredMessageHistoryList.length > 0 ? (
                    (isCODFilterActive
                      ? filteredMessageHistoryList.filter(
                        (message) =>
                          message?.MessageStatus === "C.O.D Pending"
                      )
                      : filteredMessageHistoryList
                    ).length === 0 ? (
                      <div className="animated-message text-center">
                        <span>
                          {isCODFilterActive
                            ? "No COD Messages"
                            : searchHistoryList
                              ? "No search results"
                              : "No Messages"}
                        </span>
                      </div>
                    ) : (
                      (isCODFilterActive
                        ? filteredMessageHistoryList.filter(
                          (message) =>
                            message?.MessageStatus === "C.O.D Pending"
                        )
                        : filteredMessageHistoryList
                      ).map((message, index) => (
                        <div
                          key={index}
                          className={`widget-chat-item with-media ${message?.Sender === "Inmate"
                            ? "start inmate-chat"
                            : "end"
                            }`}
                        >
                          <div className="widget-chat-info">
                            {message?.IsSenderMsgDelete !== true &&
                              showCheckbox &&
                              message?.Sender === "PublicUser" && (
                                <input
                                  type="checkbox"
                                  className="me-1"
                                  name={message?.MessageID}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e, // Pass the checked state
                                      message.MessageID,
                                      message.MessageBodyText,
                                      message.FacilityMessageCost,
                                      message
                                    )
                                  }
                                  checked={
                                    isCheckboxChecked[message.MessageID]
                                      ?.checked || false
                                  } // Access the `checked` property safely
                                />
                              )}

                            <div
                              className={`widget-chat-info-container message-bubble text-wrap ${message?.Sender === "PublicUser"
                                ? "public-user-bg"
                                : ""
                                }`}
                            >
                              {/* {message?.Sender === "Inmate" &&
                              message?.MessageStatus !== "C.O.D Pending" && filteredMessageHistoryList?.length !== index +1 &&(
                                <button
                                  className="delete-icon-btn"
                                  onClick={() =>
                                    handleClickDeleteConfiramtion(message?.MessageID)
                                  }
                                >
                                  <i className="fas fa-trash-alt"></i>{" "}
                                  {/* Replace with your preferred delete icon */}
                              {/* </button>
                             } */}

                              {message?.Sender === "Inmate" &&
                                message?.MessageStatus !== "C.O.D Pending" &&
                                filteredMessageHistoryList?.length !==
                                index + 1 &&
                                (multiDeleteMenuActive ? (
                                  // Show the checkbox when multiDeleteMenuActive is true
                                  <input
                                    type="checkbox"
                                    className="delete-checkbox"
                                    checked={selectedDeleteMessages.includes(
                                      message?.MessageID
                                    )} // Bind to state
                                    onChange={() =>
                                      handleMultiDeleteCheckboxChange(
                                        message?.MessageID
                                      )
                                    }
                                  />
                                ) : (
                                  // Show the delete icon when multiDeleteMenuActive is false
                                  <button
                                    className="delete-icon-btn"
                                    onClick={() =>
                                      handleClickDeleteConfiramtion(
                                        message?.MessageID
                                      )
                                    }
                                  >
                                    <i className="fas fa-trash-alt"></i>{" "}
                                    {/* Replace with your preferred delete icon */}
                                  </button>
                                ))}

                              {/* Message Bubble */}

                              {/* ---------- Print COD Messages --------------- */}
                              {message?.MessageStatus === "C.O.D Pending" ? (
                                <div
                                  className="message-box-user-send"
                                  id="divBodyCont"
                                >
                                  {(message?.IsSenderMsgDelete === false) ? (
                                    //   {message?.IsSenderMsgDelete === false ? (
                                    <div className="card mb-2 card-message">
                                      <div className="card-body position-relative">
                                        <p className="card-text text-default-red mb-3 mt-4">
                                          {currentLang?.inbox?.COD_Message}
                                          <br />
                                          {currentLang?.inbox?.Click_to_Approve}
                                        </p>
                                        {!isCODFilterActive && (
                                          <div className="position-absolute top-0 end-0 mt-2 me-3">
                                            <button
                                              id="codApprove"
                                              className="btn btn-success btn-sm d-flex align-items-center"
                                              title={currentLang?.inbox?.Approve_Reject}
                                              onClick={() => codUpdate(message)}
                                            >
                                              {currentLang?.inbox?.Approve_Reject}
                                              <i className="fa fa-eye ms-2"></i>
                                            </button>
                                          </div>
                                        )}
                                        <div className="widget-chat-messages">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                message?.MessageBody.replace(
                                                  /\n/g,
                                                  "<br />"
                                                ),
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="card mb-2 card-message">
                                      <div className="card-body position-relative">
                                        <div className="widget-chat-messages">
                                          {/* {message?.MessageBodyText} */}
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                message?.MessageBody.replace(
                                                  /\n/g,
                                                  "<br />"
                                                ),
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                //  ----------- Normal Message Print Here ----------------------------
                                <div className="widget-chat-message-container d-flex flex-column align-items-start">
                                  <div className="widget-chat-messages p-2">
                                    {/* {message?.MessageBodyText} */}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: message?.MessageBody.replace(
                                          /\n/g,
                                          "<br />"
                                        ),
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* Date, Time, and Tick Display */}
                            <div className="message-metadata">
                              {/* Tick Status */}
                              {message?.Sender === "PublicUser" && (
                                <span>
                                  {message?.MessageStatus === "Read" ? (
                                    <span className="tick-icon text-success me-1">
                                      <img
                                        src={doubleTick}
                                        alt="Double Tick"
                                        className="img-fluid"
                                      />
                                    </span>
                                  ) : message?.MessageStatus === "Unread" ? (
                                    <span className="tick-icon text-primary me-1">
                                      <img
                                        src={tick}
                                        alt="Single Tick"
                                        className="img-fluid"
                                      />
                                    </span>
                                  ) : (
                                    <span className="tick-icon text-secondary me-1">
                                      <i className="fa fa-clock"></i>{" "}
                                      {/* Timer Icon */}
                                    </span>
                                  )}
                                </span>
                              )}

                              {/* Date and Time */}
                              <span>
                                {
                                  message?.MessageSentDate
                                }
                              </span>
                            </div>
                            {message?.IsSenderMsgDelete !== true &&
                              showCheckbox &&
                              message?.Sender === "Inmate" && (
                                <input
                                  type="checkbox"
                                  className="me-1"
                                  style={{ "margin-left": "5px" }}
                                  name={message?.MessageID}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e, // Pass the checked state
                                      message.MessageID,
                                      message.MessageBodyText,
                                      message.FacilityMessageCost,
                                      message
                                    )
                                  }
                                  checked={
                                    isCheckboxChecked[message.MessageID]
                                      ?.checked || false
                                  } // Access the `checked` property safely
                                />
                              )}
                          </div>
                        </div>
                      ))
                    )
                  ) : (
                    <div className="animated-message text-center">
                      <span>
                        {isCODFilterActive
                          ? currentLang?.inbox?.No_COD_Messages
                          : searchHistoryList
                            ? currentLang?.inbox?.No_search_results
                            : currentLang?.inbox?.No_Messages}
                      </span>
                    </div>
                  )}
                </div>

                {/* Chat Area - Footer (Textarea and send/save button) */}
                <div className="widget-chat-input  font-size-15 p-3 border-top mb-3">
                  <div
                    className={`container ${isMessageDisabled ? "disabled" : ""
                      }`}
                  >
                    {isMessageDisabled ? (
                      <div
                        className="alert alert-warning text-center"
                        role="alert"
                      >
                        <strong>{messageDisabled}</strong>
                      </div>
                    ) : (
                      <div className="row">
                        <div>
                          <div className="mb-1 position-relative">
                            {/* --------------------- Send Message / Draft - Text Area & Button Functionality handling */}
                            <label className="form-label inmate-label">
                              {currentLang?.labels?.Message}<span className="text-danger ps-1">*</span>
                            </label>
                            <div className="input-group">
                              <textarea
                                ref={descInputRef}
                                value={message?.messageBody}
                                // onKeyDown={handleKeyDown}
                                onKeyDown={(e) => {
                                  restrictCharacters(e); // Apply character restriction
                                  handleKeyDown(e);
                                }}
                                onKeyUp={handleKeyUp}
                                name="messageBody"
                                className="form-control mb-5px fw-normal pe-5"
                                rows="3"
                                placeholder={currentLang?.placeholders?.txtMessage}
                                onChange={(e) => handleChange(e, true)}
                                onCopy={(e) => e.preventDefault()}
                                onClick={handleInputClick}
                                onCut={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                                onFocus={handleMessageFocus}
                                onBlur={handleMessageBlur}
                                errorMessage={errors?.messageBody}
                                autocomplete="off"
                              //disabled={disabledItems?.cancelConnection} // Disable textarea
                              ></textarea>
                              {emojiEnabled && (
                                <span
                                  className="input-group-text animated-emoji-description"
                                  style={{ zIndex: 10 }}
                                  onClick={() => handleIconClick("messageBody")}
                                >
                                  😊
                                </span>
                              )}
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                                  {errors && errors["messageBody"]}
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="fs-5 text-end">
                                  {getDisplayLength(message?.messageBody)}/
                                  {maxDescriptionLength} {currentLang?.inbox?.characters}
                                </div>
                              </div>
                            </div>
                            {isDescIconPickerOpen && isMessageFocused && (
                              <div
                                className="dropdown-menu show p-2 overflow-auto position-change-top"
                                ref={emojiPickerRef} tabIndex={-1}
                                onMouseDown={(e) => {
                                  const isIOS = /iPad|iPhone|iPod/.test(
                                    navigator.userAgent
                                  );
                                  if (isIOS) {
                                    e.preventDefault(); // Prevent input blur only on iOS
                                  }
                                }}
                              >
                                <EmojiPicker
                                  onEmojiSelect={(emoji) =>
                                    handleEmojiSelect(emoji, "messageBody")
                                  }
                                  onClose={() => setIsDescIconPickerOpen(false)}
                                />
                              </div>
                            )}
                          </div>
                          {/* Action Buttons */}
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3">
                            <div>
                              <button
                                className="btn btn-success mb-2 me-2 font-size-14"
                                onClick={handleMessageSend}
                                disabled={disabledItems?.cancelConnection} // Disable button
                              >
                                <i className="fa fa-paper-plane me-1"></i>{currentLang?.buttons?.Send}
                              </button>

                              <button
                                className="btn btn-danger me-2 mb-2 font-size-14"
                                onClick={handleSaveasDraft}
                                title={
                                  isDraftEdited
                                    ? currentLang?.buttons?.UpdateDraft
                                    : currentLang?.buttons?.SaveAsDraft
                                }
                                disabled={disabledItems?.cancelConnection} // Disable button
                              >
                                <i
                                  className={`fa ${isDraftEdited ? "fa-edit" : "fa-save"
                                    } me-1`}
                                ></i>
                                {draft?.draftID > 0
                                  ? currentLang?.buttons?.UpdateDraft
                                  : currentLang?.buttons?.SaveAsDraft}
                              </button>
                              {/* Select All Checkbox - Delete */}
                              {/* <div className="select-all-checkbox"> */}

                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* ------- Popup for Send Message - Confirmation -------------- */}
            <ConfirmationModal
              show={SendMessageConfirmation}
              onHide={handleCancelMessage}
              onConfirm={handleMessageSentConfirm}
              title={currentLang?.Message}
              messageHTML={
                shouldDisplayHTMLMessage && message?.messageEmojiCost > 0
                  ? `${currentLang?.InboxPopContent?.Send_MSG_Confirm} </br>
                  ${currentLang?.inbox?.Total_Cost} <b style="color:${message?.messageCost > 0 ? "#4a9a93" : "#C8605E"
                  };">$${message?.messageCost}</b> 
                    (${currentLang?.inbox?.Message_Cost} <b style="color:${PublicInboxMessageSubjectList?.FacilityMessageCost > 0
                    ? "#4a9a93"
                    : "#C8605E"
                  };">$${PublicInboxMessageSubjectList?.FacilityMessageCost?.toFixed(
                    2
                  )}</b> 
                    + ${currentLang?.inbox?.Emoji_Cost} <b style="color:${message?.messageEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                  };">$${message?.messageEmojiCost}</b>)</br>`
                  : `<p>${currentLang?.InboxPopContent?.Send_MSG_Confirm}</p>`
              }
              message={
                (message.messageCost > 0
                  ? `\n ${currentLang?.inbox?.Total_Cost} $${message.messageCost
                  } ( ${currentLang?.inbox?.Message_Cost} $${PublicInboxMessageSubjectList?.FacilityMessageCost?.toFixed(
                    2
                  )} + ${currentLang?.inbox?.Emoji_Cost} $${message.messageEmojiCost})`
                  : "") + currentLang?.InboxPopContent?.Send_MSG_Confirm
              }
              onconfirmname={currentLang?.buttons?.Yes}
              oncancelname={currentLang?.buttons?.No}
            //  message={"Are you sure you want to send?"}
            />
            {/* ---------------------- Multi C.O.D Message Initial popup Show ---------------------------- */}
            <InboxPopup
              show={multiCODPopup}
              onHide={() => {
                setMultiCODPopup(false);
              }}
              closeButton={() => {
                setMultiCODPopup(false);
              }}
              onConfirm={handleMultiApproveCODMessage}
              title={currentLang?.Message}
              messageHTML={
                multiCODPopup && message.messageEmojiCost > 0
                  ? ` ${currentLang?.inbox?.Total_Cost} <b style="color:${message?.messageCost > 0 ? "#4a9a93" : "#C8605E"
                  };">$${message?.messageCost
                  }</b> (${currentLang?.inbox?.Message_Cost} <b style:"color:${multiCODCost > 0 ? "#4a9a93" : "#C8605E"
                  };"> $${multiCODCost?.toFixed(
                    2
                  )}</b> + ${currentLang?.inbox?.Emoji_Cost} <b style: "color: ${message?.messageEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                  };"> $${message?.messageEmojiCost
                  })</b><>${currentLang?.InboxPopContent?.What_Would_You_Like}`
                  : currentLang?.InboxPopContent?.Approve_MSG_Confirm
              }
              message={
                (message.messageEmojiCost > 0
                  ? `\n${currentLang?.inbox?.Total_Cost} $${message.messageCost
                  } (${currentLang?.inbox?.Message_Cost} $${PublicInboxMessageSubjectList?.FacilityMessageCost?.toFixed(
                    2
                  )} + ${currentLang?.inbox?.Emoji_Cost} $${message.messageEmojiCost})`
                  : "") + currentLang?.InboxPopContent?.What_Would_You_Like
              }
              // message={"What would you like to do?"}
              onconfirmname={currentLang?.buttons?.Yes}
              oncancelname={currentLang?.buttons?.No}
            />

            {/* -------------------------------  Multi C.O.D Message Reject --------------------------------------- */}
            <ConfirmationModal
              show={multiCODPopupReject}
              closeButton={() => setMultiCODPopupReject(false)}
              onHide={() => setMultiCODPopupReject(false)}
              onConfirm={handleMultiRejectCODMessage}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Reject_MSG_Confirm}
            />
            {/* ---------------------- C.O.D Message Initial popup Show ---------------------------- */}
            <InboxPopup
              show={cODApproveRejectMessage}
              onHide={handleRejectCODMessage}
              closeButton={() => {
                setCODApproveRejectMessage(false);
              }}
              onConfirm={handleApproveCODMessage}
              title={currentLang?.Message}
              messageHTML={
                cODApproveRejectMessage && message.messageEmojiCost > 0
                  ? ` ${currentLang?.inbox?.Total_Cost} <b style="color:${message?.messageCost > 0 ? "#4a9a93" : "#C8605E"
                  };">$${message?.messageCost}</b> 
                  (${currentLang?.inbox?.Message_Cost} <b style = "color:${PublicInboxMessageSubjectList?.FacilityMessageCost > 0
                    ? "#4a9a93"
                    : "#C8605E"
                  };"> $${PublicInboxMessageSubjectList?.FacilityMessageCost.toFixed(
                    2
                  )}</b> + 
                  ${currentLang?.inbox?.Emoji_Cost} <b style = "color: ${message?.messageEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                  };"> $${message?.messageEmojiCost
                  })</b></br>${currentLang?.InboxPopContent?.What_Would_You_Like}`
                  : currentLang?.InboxPopContent?.What_Would_You_Like
              }
              message={
                (message.messageEmojiCost > 0
                  ? `\n${currentLang?.inbox?.Total_Cost} $${message.messageCost
                  } (${currentLang?.inbox?.Message_Cost} $${PublicInboxMessageSubjectList?.FacilityMessageCost?.toFixed(
                    2
                  )} +  ${currentLang?.inbox?.Emoji_Cost} $${message.messageEmojiCost})`
                  : "") + currentLang?.InboxPopContent?.What_Would_You_Like
              }
              // message={"What would you like to do?"}
              onconfirmname={currentLang?.inbox?.Approve}
              oncancelname={currentLang?.inbox?.Reject}
            />
            {/* --------------------- C.O.D Message Approve or Reject Popup ---------------------------- */}
            <InboxPopup
              show={codInfoPopup}
              closeButton={() => setCODInfoPopup(false)}
              onConfirm={handleCODInfoPopupClose}
              title={currentLang?.Message}
              showCancelButton={false}
              size={"lg"}
              messageColor="#c8605e"
              onconfirmname={currentLang?.buttons?.OK}
              message={currentLang?.InboxPopContent?.COD_MessageList}
            />
            {/* ------------------------------- Message Delete Conversation Popup --------------------------------------- */}
            <ConfirmationModal
              show={deleteMesssagePopup}
              closeButton={() => setDeleteMessagePopup(false)}
              // onHide={() => setDeleteMessagePopup(false)}
              onHide={() => handleSingleDelete()}
              onConfirm={handleDeleteMessageClick}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Delete_Conversation}
            />

            {/* --------------------------- New Message Confirmation Popup --------------------------------------------- */}
            <ConfirmationModal
              show={newMessage}
              closeButton={() => setNewMessage(false)}
              // onHide={() => setNewMessage(false)}
              onHide={() => handleClose()}
              onConfirm={handleClickNewMessage}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Redirect_Page}
              onconfirmname={currentLang?.buttons?.Yes}
            />

            {/* --------------------------- Message History Confirmation Popup --------------------------------------------- */}
            <ConfirmationModal
              show={inboxHistoryPopup}
              closeButton={() => setInboxHistoryPopup(false)}
              onHide={() => setInboxHistoryPopup(false)}
              onConfirm={handleNavigateInboxHistory}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Redirect_Page}
              onconfirmname={currentLang?.buttons?.Yes}
            />

            {/* --------------------------- Purchase Credits Confirmation Popup --------------------------------------------- */}
            <ConfirmationModal
              show={purchaseCreditPopup}
              closeButton={() => setPurchaseCreditPopup(false)}
              // onHide={() => setPurchaseCreditPopup(false)}
              onHide={() => handlePurchaseCreditPopupClose()}
              onConfirm={handleClickRedirectPurchaseCredit}
              title={currentLang?.Message}
              onconfirmname={currentLang?.buttons?.Yes}
              message={currentLang?.InboxPopContent?.Redirect_Page}
            />
            {/* --------------------------- Cancel Connection Popup --------------------------------------------- */}
            <ConfirmationModal
              show={cancelConnectionPopup}
              closeButton={() => setCancelConnectionPopup(false)}
              // onHide={() => setCancelConnectionPopup(false)}
              onHide={() => handleCancelConnectionPopupClose()}
              onConfirm={handleClickUpdateConnection}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Cancel_Connection}
              onconfirmname={currentLang?.buttons?.Yes}
            />
            {/* --------------------------- MultiDelete Conversation Popup --------------------------------------------- */}
            <ConfirmationModal
              show={multiDeleteConfirmation}
              closeButton={() => setMultiDeleteConfirmation(false)}
              onHide={() => setMultiDeleteConfirmation(false)}
              onConfirm={handleMultiDeleteConfirmClick}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Delete_Conversation}
              onconfirmname={currentLang?.buttons?.Yes}
            />

            {/* --------------------------- Cancel Connection Popup --------------------------------------------- */}
            <ConfirmationModal
              show={cancelConnectionPopup}
              closeButton={() => setCancelConnectionPopup(false)}
              onHide={() => setCancelConnectionPopup(false)}
              onConfirm={handleClickUpdateConnection}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.Cancel_Connection}
              onconfirmname={currentLang?.buttons?.Yes}
            />
            {/*-----------------------------Lock Down Popup ---------------------------------------------------------------*/}
            <ConfirmationModal
              show={isPaymentMsg}
              onHide={handlePaymentMsg}
              onConfirm={handlePaymentMsg}
              title={currentLang?.Message}
              message={paymentMsg}
              showCancelButton={false}
              closeButton={false}
              onconfirmname={currentLang?.buttons?.OK}
            />
            {/* --------------------- Emonji status Popup ---------------------------- */}
            <ConfirmationModal
              show={emonjiStatusPopup}
              onHide={() => setemonjiStatusPopup(false)} // Correctly passes the close handler
              onConfirm={handleEmonjiStatusPopupConfirm}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.NO_Emojis_Access}
              onconfirmname={currentLang?.buttons?.Yes}
            />
            <ConfirmationModal
              show={sendemonjiRectPopup}
              closeButton={() => setsendemonjiRectPopup(false)}
              onConfirm={handlesendemonjiRectPopupClose}
              onHide={handlesendemonjiRectPopupClose}
              title={currentLang?.Message}
              showCancelButton={false}
              size={"lg"}
              messageColor="#c8605e"
              onconfirmname={currentLang?.buttons?.OK}
              message={currentLang?.inboxHistoryPopup?.NO_Longer_Emojis_Access}
            />
            {/* Modal Popup for redirect purchase credit */}
            <ConfirmationModal
              show={isCreditamountModal}
              // onHide={handleCancelMessage}
              onConfirm={handleClickRedirectPurchaseCredit}
              title={currentLang?.Message}
              message={msgCreditamount}
              showCancelButton={false} // Pass 'false' to hide the "No" button
              messageColor="#FF7F7F"
              size={"lg"}
              onconfirmname={currentLang?.buttons?.Yes}
              closeButton={false}
            />
            {/* Modal Popup for Restricted Keywords */}
            <ConfirmationModal
              show={keywordPopup}
              onHide={() => setKeywordPopup(false)} // Correctly passes the close handler
              onConfirm={() => setKeywordPopup(false)}
              title={currentLang?.Message}
              message={foundKeyword}
              onconfirmname={currentLang?.buttons?.OK}
              closeButton={false}
              showCancelButton={false}
            />

            {/* Modal Popup for Emoji Permission */}
            <ConfirmationModal
              show={IsHasMsgEmojiPermission}
              onHide={handleCancelMsgEmojiPermission}
              onConfirm={handleClickMsgEmojiPermission}
              title={currentLang?.Message}
              message={currentLang?.InboxPopContent?.NO_Emojis_Access}
              showCancelButton={true}
              onconfirmname={currentLang?.buttons?.Yes}
              closeButton={false}
            />
          </div>
          {/* -------------------- Right Section - show Available Credits and Shotcuts -------------------------- */}
          <div
            className="col-12 col-lg-4"
            style={{
              height: "auto",
              flex: 1, // Allow this column to stretch and match the height of the image column
            }}
          >
            <div className="cl-left-menu-message ">
              <div className="card border-radius-all shadow-sm bg-white">
                <div className="">
                  <div className="messenger-content border-radius-all">
                    <div className="widget-chat border-radius-all mb-3">
                      {/* ------------------------------------ Available Credits Section ------------------------------------------------- */}
                      <div className="available-credits-section flex-wrap">
                        <div className="credit-item">
                          <h6 title={currentLang?.AvailableCredits} className="">
                            {currentLang?.AvailableCredits}
                            <span
                              className={`noWrap class-balance ml-5 ${PublicInboxMessageSubjectList?.CreditBalance ===
                                0 ||
                                PublicInboxMessageSubjectList?.CreditBalance <
                                PublicInboxMessageSubjectList?.FacilityMessageCost
                                ? "text-danger" // Add a class for red color if the balance is 0
                                : "text-default-success"
                                }`}
                            >
                              $
                            </span>
                            <span
                              className={`lblUserCreditBalance ${PublicInboxMessageSubjectList?.CreditBalance ===
                                0 ||
                                PublicInboxMessageSubjectList?.CreditBalance <
                                PublicInboxMessageSubjectList?.FacilityMessageCost
                                ? "text-danger" // Add a class for red color if the balance is 0
                                : ""
                                }`}
                            >
                              {PublicInboxMessageSubjectList?.CreditBalance?.toFixed(
                                2
                              ) || "0.00"}
                            </span>
                          </h6>
                        </div>

                        <div className="cost-item">
                          <h6 title="Message Cost" className="">
                            {currentLang?.inbox?.MessageCost}:
                            <span className="noWrap text-default-success ml-5">
                              $
                            </span>
                            <span className="lblFacilityMessageCost">
                              {parseFloat(
                                PublicInboxMessageSubjectList?.FacilityMessageCost ||
                                "0.00"
                              ).toFixed(2)}
                            </span>
                          </h6>
                        </div>
                        {emojiEnabled === true && (
                          <div className="emoji-cost-item">
                            <h6 title="Emoji Cost" className="">
                              {currentLang?.inbox?.EmojiCost}:
                              <span className="noWrap text-default-success ml-5">
                                $
                                <span className="lblFacilityEmojiCost">
                                  {parseFloat(
                                    PublicInboxMessageSubjectList?.FacilityEmojiCost ||
                                    "0.00"
                                  ).toFixed(2)}
                                </span>
                              </span>
                            </h6>
                            <span
                              data-placement="bottom"
                              data-html="true"
                              data-toggle="tooltip"
                              title={currentLang?.InboxPopContent?.Same_Emoji}
                              className=""
                            >
                              <i className="fa fa-info-circle"></i>
                            </span>
                          </div>
                        )}
                      </div>
                      {/* ------------------------------------ Left Side Menus ------------------------------------------------- */}
                      <ul className="submenu-list">
                        {/* --------------------------------- Menu for new Message -------------------------------------------------- */}
                        <li
                          id="liNewMail"
                          className={`ActiveSubmenu ActiveNewMail ${disabledItems?.newMessage
                            ? "opacity-50 no-hover"
                            : ""
                            }`}
                          title={
                            disabledItems?.newMessage
                              ? currentLang?.tooltip?.permission
                              : currentLang?.inbox?.NewMessage
                          }
                          // onClick={
                          // !disabledItems?.newMessage
                          //   ? () => setNewMessage(true)
                          //   : undefined
                          // }
                          onClick={() => handleQuickMenu()}
                        >
                          {currentLang?.inbox?.NewMessage}
                          <label className="pointer float-end">
                            <i class="fa-solid fa-envelope"></i>
                          </label>
                        </li>
                        {/* --------------------------------- Menu for Purchase History -------------------------------------------- */}
                        <li
                          className="liMailHistory ActiveSubmenu"
                          title={currentLang?.inbox?.MessageHistory}
                          onClick={() => handleNavigateInboxHistory()}
                        >
                          {currentLang?.inbox?.MessageHistory}
                          <label className="pointer float-end">
                            <i className="fa fa-archive pointer"></i>
                          </label>
                        </li>
                        {/* -------------------------------- Menu for Purchase Credits ------------------------------------------------ */}
                        <li
                          id="liPurchaseCredits"
                          className={`ActiveSubmenu ActivePurchaseCredits ${disabledItems?.purchaseCredits
                            ? "opacity-50 no-hover"
                            : ""
                            }`}
                          title={
                            disabledItems?.purchaseCredits
                              ? currentLang?.tooltip?.permission
                              : currentLang?.inbox?.PurchaseCredits
                          }
                          // onClick={
                          // !disabledItems?.purchaseCredits
                          //   ? () => setPurchaseCreditPopup(true)
                          //     : undefined
                          // }
                          onClick={() => handlePurchaseCreditQuickMenu()}
                        >
                          {currentLang?.inbox?.PurchaseCredits}
                          <label className="pointer float-end">
                            <i className="fa fa-shopping-cart pointer"></i>
                          </label>
                        </li>

                        {/* ---------------------------------- Menu for filter COD Message ------------------------------------------ */}

                        <li
                          className={`lifilterCODMessages ActiveSubmenu ${isCODFilterActive ? "active" : ""
                            }`}
                          title={currentLang?.inbox?.FilterCODMessages}
                          onClick={handleFilterCODMessages}
                        >
                          {currentLang?.inbox?.FilterCODMessages}
                          <label className="pointer float-end">
                            <i className="fa fa-filter pointer"></i>
                          </label>
                        </li>
                        {showCheckbox && (
                          <div className="ms-4 mb-2 d-flex justify-content-start align-items-center">
                            <label>
                              <input
                                className="select-all me-1"
                                type="checkbox"
                                onChange={handleSelectAllChange}
                                checked={isSelectAllChecked}
                              />
                              {currentLang?.inbox?.Select_All}
                            </label>
                          </div>
                        )}
                        {isAnyCheckboxChecked && (
                          <button
                            className="btn btn-success mb-2 me-2 ms-4 font-size-14"
                            //onClick={handleMessageSend}
                            onClick={() => MulitCodUpdate(message)}
                          >
                            {currentLang?.inbox?.Approve}
                          </button>
                        )}
                        {isAnyCheckboxChecked && (
                          <button
                            className="btn btn-danger mb-2 me-2 font-size-14"
                            //onClick={handleMessageSend}
                            onClick={() => setMultiCODPopupReject(true)}
                          >
                            {currentLang?.inbox?.Reject}
                          </button>
                        )}
                        {isAnyCheckboxChecked && (
                          <button
                            className="btn btn-warning mb-2 me-2 font-size-14"
                            onClick={handleMultiCancelMessages}
                          >
                            {currentLang?.inbox?.Cancel}
                          </button>
                        )}
                        {/* -------------------------------------- Menu for Delete Conversation --------------------------------------- */}
                        {!disabledItems?.deleteConversation && (
                          <li
                            id="liDeleteConversation"
                            //  className="ActiveSubmenu PrintMessage"
                            className={`lideletemessages ActiveSubmenu ${multiDeleteMenuActive ? "active" : ""
                              } ${deleteConversation ? "opacity-50 no-hover" : ""
                              }`}
                            title={currentLang?.inbox?.DeleteConversation}
                            onClick={handleMultiDeleteClick}
                          >
                            {currentLang?.inbox?.DeleteConversation}
                            <label className="pointer float-end">
                              <i className="fa fa-trash pointer"></i>
                            </label>
                          </li>
                        )}
                        {multiDeleteMenuActive && (
                          <>
                            <div className="ms-4 mb-2 d-flex justify-content-start align-items-center">
                              <input
                                type="checkbox"
                                className="select-all"
                                id="selectAllDelete"
                                checked={
                                  selectedDeleteMessages.length ===
                                  filteredMessageHistoryList
                                    .slice(
                                      0,
                                      filteredMessageHistoryList.length - 1
                                    ) // Exclude the last message
                                    .filter(
                                      (message) => message.Sender === "Inmate"
                                    ).length
                                }
                                onChange={handleSelectAllDeleteChange}
                              />
                              <label className="ms-1" htmlFor="selectAllDelete">
                                {currentLang?.inbox?.Select_All_to_Delete}
                              </label>
                            </div>
                          </>
                        )}
                        {selectedDeleteMessages?.length > 0 &&
                          multiDeleteMenuActive === true && (
                            <div>
                              <button
                                className="btn btn-danger mb-2 me-2 ms-4 font-size-14"
                                onClick={handleMultiDeleteMessages} // Replace with your rejection handler
                              >
                                {currentLang?.inbox?.Delete}
                              </button>

                              <button
                                className="btn btn-warning mb-2 me-2 font-size-14"
                                onClick={handleMultiDeleteCancelMessages} // Replace with your cancel handler
                              //  disabled={disabledItems?.cancelConnection} // Disable button if cancelConnection is true
                              >
                                {currentLang?.inbox?.Cancel}
                              </button>
                            </div>
                          )}

                        {/* ------------------------------------ Cancel Connection Menu ------------------------------------------------- */}
                        <li
                          className={`ActiveSubmenu ActiveCancelConnection ${disabledItems?.cancelConnection
                            ? "opacity-50 no-hover"
                            : ""
                            }`}
                          title={
                            disabledItems?.cancelConnection
                              ? currentLang?.tooltip?.permission
                              : currentLang?.inbox?.CancelConnection
                          }
                          // onClick={
                          //   !disabledItems?.cancelConnection
                          //     ? () => setCancelConnectionPopup(true)
                          //     : undefined
                          // }
                          onClick={() => handleCancelConnection()}
                        >
                          {/* Cancel Connection */}{currentLang?.inbox?.CancelConnection}
                          <label className="pointer float-end">
                            <i className="fa fa-times-circle pointer"></i>
                          </label>
                        </li>
                        {/* ------------------------------------ Print Message - Menu ------------------------------------------------- */}
                        <li
                          id="liPrintMessage"
                          className="ActiveSubmenu PrintMessage"
                          title={currentLang?.inbox?.PrintMessage}
                          onClick={handlePrintShow}
                        >
                          {/* Print Message */} {currentLang?.inbox?.PrintMessage}
                          <label className="pointer float-end">
                            <i className="fa fa-print pointer"></i>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loader}
        </div>
      </div>
      <div style={{ display: "none" }}>
        <form
          ref={componentRef}
          style={isPrintData ? { display: "block" } : { display: "none" }}
        >
          <div className="container-fluid">
            <div className="w-100">
              <div className="p-2">
                <h4 className="text-center font-size-25">
                  {currentLang?.inbox?.Message_Conversation}
                </h4>
                <div className="message-container">
                  {/* <h2>Message Conversation</h2> */}
                  {publicInboxMessageHistoryList &&
                    publicInboxMessageHistoryList.length > 0 ? (
                    (isCODFilterActive &&
                      publicInboxMessageHistoryList.filter(
                        (message) => message?.MessageStatus === "C.O.D Pending"
                      ).length > 0
                      ? publicInboxMessageHistoryList.filter(
                        (message) =>
                          message?.MessageStatus === "C.O.D Pending"
                      )
                      : publicInboxMessageHistoryList
                    ).map((message) => (
                      <div
                        key={message.id}
                        className="message-box mb-3"
                        style={{ fontSize: "18px" }}
                      >
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th colSpan="2">
                                {message.MessageSentDate} -{" "}
                                {message.MessageStatus}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <b>{currentLang?.inbox?.From}</b>
                              </td>
                              <td>{message?.MessageFrom}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{currentLang?.inbox?.To}</b>
                              </td>
                              <td>{message?.MessageTo}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{currentLang?.inbox?.Subject}</b>
                              </td>
                              <td>{message?.MessageSubject}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{currentLang?.inbox?.Body}</b>
                              </td>
                              <td
                                style={{
                                  maxWidth: "100%",
                                  wordBreak: "break-word",
                                  whiteSpace: "pre-wrap",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {message.MessageBodyText ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: message?.MessageBody.replace(
                                        /\n/g,
                                        "<br />"
                                      ),
                                    }}
                                  />
                                ) : (
                                  "No content"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>{currentLang?.inbox?.Status}</b>
                              </td>
                              <td>{message.MessageStatus || "No content"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))
                  ) : (
                    <div className="alert alert-info">{currentLang?.inbox?.No_messages_found}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default React.memo(Messenger);
